/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  ClaimContacts,
  ClaimFamilies,
  CreateAdminInput,
  CreateTravelAgencyCompanyInput,
  ListAdminResponse,
  ListBusinessTravelCompanies,
  ListClaimGroups,
  ListGdsOffices,
  ListTask,
  Model1,
  Model2,
  ReceivableContractsStatus,
  SavedSearches,
  UsersTicketsHistorySchema,
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Admin<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
  /**
   * No description
   *
   * @tags Admin
   * @name ListAdmin
   * @summary List admins
   * @request GET:/admin/admins
   * @secure
   */
  listAdmin = (params: RequestParams = {}) =>
    this.request<ListAdminResponse, any>({
      path: `/admin/admins`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name CreateAdmin
   * @summary Create an admin (without inviting)
   * @request POST:/admin/admins
   * @secure
   */
  createAdmin = (body: CreateAdminInput, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/admins`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListBusinessTravelCompanies
   * @summary List business travel companies
   * @request GET:/admin/business-travel-companies
   * @secure
   */
  listBusinessTravelCompanies = (params: RequestParams = {}) =>
    this.request<ListBusinessTravelCompanies, any>({
      path: `/admin/business-travel-companies`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name CreateTravelAgencyCompany
   * @summary Create a business travel company
   * @request POST:/admin/business-travel-companies
   * @secure
   */
  createTravelAgencyCompany = (body: CreateTravelAgencyCompanyInput, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/business-travel-companies`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListAllCourts
   * @summary List all courts
   * @request GET:/admin/courts
   * @secure
   */
  listAllCourts = (params: RequestParams = {}) =>
    this.request<Model2, any>({
      path: `/admin/courts`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListGdsOffices
   * @summary List travel agency's GDS offices
   * @request GET:/admin/gds-offices
   * @secure
   */
  listGdsOffices = (params: RequestParams = {}) =>
    this.request<ListGdsOffices, any>({
      path: `/admin/gds-offices`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListHearings
   * @summary List hearings. You can group them by juridiction and filter by ongoing hearings (Used in enrollment flow)
   * @request GET:/admin/hearings
   * @secure
   */
  listHearings = (
    query?: {
      procedure?: "ongoing";
      groupBy?: "juridiction";
    },
    params: RequestParams = {},
  ) =>
    this.request<Model1, any>({
      path: `/admin/hearings`,
      method: "GET",
      query: query,
      secure: true,
      ...params,
    });
  /**
   * @description Return private and globally saved searches
   *
   * @tags Admin
   * @name GetSavedSearches
   * @summary Get saved searches
   * @request GET:/admin/search
   * @secure
   */
  getSavedSearches = (params: RequestParams = {}) =>
    this.request<SavedSearches, any>({
      path: `/admin/search`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description It saves the query paramaters of a search to easily access it later
   *
   * @tags Admin
   * @name SaveSearch
   * @summary Save a search
   * @request POST:/admin/search
   * @secure
   */
  saveSearch = (
    body: {
      /** Ais generated query */
      query: string;
      /** @minLength 1 */
      name: string;
      /**
       * Upclaim admin can save search for everyone
       * @default true
       */
      isPrivate: boolean;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        /** @min 1 */
        id: number;
        adminId: string;
        /** @example "Ais generated query" */
        query: string;
        /**
         * @minLength 1
         * @example "Audience du mois"
         */
        name: string;
        /** @format date-time */
        createdAt: Date;
      },
      any
    >({
      path: `/admin/search`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name GetBoxToken
   * @summary Get Box token to use Box UI elements
   * @request GET:/admin/admins/box-token
   * @secure
   */
  getBoxToken = (params: RequestParams = {}) =>
    this.request<
      {
        accessToken: string;
        accessTokenTTLMS: number;
        acquiredAtMS: number;
        refreshToken?: string;
      },
      any
    >({
      path: `/admin/admins/box-token`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveClaimWithAllRelations
   * @summary Retrieve a claim with all relations
   * @request GET:/admin/claims/{id}
   * @secure
   */
  retrieveClaimWithAllRelations = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        id: string;
        claimTypeId: number;
        machineId: number;
        legalSpecificationId: string;
        acceptedExtraordinaryCircumstanceId?: string;
        /** Upclaim admin in charge of the case */
        assignedAdminId: string;
        /** Attorney in charge of the case */
        lawyerId: string;
        /**
         * @min 0
         * @max 20
         */
        claimLegalStepId: number;
        conversationId: string;
        parentClaimId: string;
        /** @min 1 */
        claimNumber: number;
        /** EditorJS data */
        adminNotes: string;
        customerNotes: string;
        passengersQuestion: string;
        /** @format date-time */
        nextLegalStepDueDate?: Date;
        needEligibilityVerification: boolean;
        /** @min 0 */
        claimStateId: number;
        /** @example "215592269992" */
        boxFolderId?: string;
        /** @example "228304838055" */
        boxFolderIdGeneratedRecevables?: string;
        /** @example "228304838055" */
        boxFolderIdThirdUpload?: string;
        /** @example "228304838055" */
        boxFolderIdIdentityProofs?: string;
        /** @example "228304838055" */
        boxFolderIdInvoices?: string;
        /** @format date-time */
        stateUpdatedAt: Date;
        /** @min 0 */
        tenantAssociationId?: number;
        inboxId: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        lastModified: Date;
        procedure: {
          id?: string;
          infogreffePayload: string;
          claimId: string;
          procedureType: "PROCEDURE_CLASSIQUE" | "ESCP";
          /** @example "2023F00210" */
          identifier: string;
          nextHearingId: number;
          /** @format date */
          decisionDate: Date;
          /** @format date */
          submissionDate: Date;
          statusDispayText: string;
          decisionDisplayText: string;
          /** @format date */
          createdAt: Date;
          /** @format date */
          lastModified: Date;
          juridictionId: number;
          nextHearing: {
            id: number;
            procedureId: string;
            /** @format date */
            hearingDate: Date;
            /** @format date-time */
            hearingDateIso: Date;
            lawyerId: number;
            globalUUID: string;
            /** @format date */
            lastModified: Date;
            /** @format date */
            createdAt: Date;
            hearingTypeId: number;
            afterHearingNotes: string;
            beforeHearingNotes: string;
            hearingType: {
              id: number;
              name:
                | "PLEA_HEARING"
                | "PROCEDURAL_HEARING_FOLLOWING_POSTPONEMENT_BY_US"
                | "PROCEDURAL_HEARING_FOLLOWING_POSTPONEMENT_BY_OPPOSING_PARTY"
                | "PROCEDURAL_HEARING";
            };
          };
          juridiction: {
            /** @min 1 */
            id: number;
            /** @example "Tribunal judiciaire Paris" */
            name: string;
            /** @min 1 */
            postalAddressId: number;
            /** @example 6401 */
            code: number;
            /** @example "www.greffe-tc-dax.fr" */
            website: string;
            /** @example "09h-12h/14h-17h" */
            schedule: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
          };
        };
        tenantAssociation: {
          /** @min 1 */
          id: number;
          claimId: string;
          sourceTenantId: string;
          sourceTenantType: "TRAVEL_AGENCY" | "ENTERPRISE";
          lawFirmTenantId: string;
          sourceTenant: {
            id: string;
            /** @example "Upclaim" */
            name: string;
            tenantType: "TRAVEL_AGENCY" | "ENTERPRISE" | "LAW_FIRM" | "UPCLAIM";
            /** @example "upclaim.eu" */
            domain: string;
            email: string;
            companyId: string;
            brandingId: string;
            /** @format date-time */
            createdAt: Date;
            tenantBranding?: {
              id: string;
              tenantId: string;
              logoUrl: string;
              iconUrl?: string;
              primaryColorHex?: string;
              secondaryColorHex?: string;
              backgroundColorHex?: string;
              twRadiusType?: string;
              signatureBoxUserId: string;
              /** @example "signature.upclaim.eu" */
              subdomainUri: string;
              activeCNAME: boolean;
              emailForPassengerContact?: string;
              whitelabelInboxId?: string;
              yousignWorkspaceId?: string;
              yousignExperienceId?: string;
              senderName?: string;
              replyTo?: string;
              postmarkappDomainId?: string;
              postmarkServerId?: string;
              additionalLogos: string[];
              postmarkappDomain?: {
                ID: string;
                Name: string;
                WeakDKIM: boolean;
                SPFVerified: boolean;
                DKIMVerified: boolean;
                ReturnPathDomainVerified: boolean;
                SPFHost?: string;
                SPFTextValue?: string;
                DKIMHost?: string;
                DKIMTextValue?: string;
                DKIMPendingHost?: string;
                DKIMPendingTextValue?: string;
                DKIMRevokedHost?: string;
                DKIMRevokedTextValue?: string;
                SafeToRemoveRevokedKeyFromDNS?: boolean;
                DKIMUpdateStatus?: "Pending" | "Verified" | "Failed";
                ReturnPathDomain?: string;
                ReturnPathDomainCNAMEValue?: string;
              };
              /** @format date-time */
              lastModified?: Date;
            };
          };
          lawFirmTenant?: {
            id: string;
            /** @example "Upclaim" */
            name: string;
            tenantType: "TRAVEL_AGENCY" | "ENTERPRISE" | "LAW_FIRM" | "UPCLAIM";
            /** @example "upclaim.eu" */
            domain: string;
            email: string;
            companyId: string;
            brandingId: string;
            /** @format date-time */
            createdAt: Date;
            tenantBranding?: {
              id: string;
              tenantId: string;
              logoUrl: string;
              iconUrl?: string;
              primaryColorHex?: string;
              secondaryColorHex?: string;
              backgroundColorHex?: string;
              twRadiusType?: string;
              signatureBoxUserId: string;
              /** @example "signature.upclaim.eu" */
              subdomainUri: string;
              activeCNAME: boolean;
              emailForPassengerContact?: string;
              whitelabelInboxId?: string;
              yousignWorkspaceId?: string;
              yousignExperienceId?: string;
              senderName?: string;
              replyTo?: string;
              postmarkappDomainId?: string;
              postmarkServerId?: string;
              additionalLogos: string[];
              postmarkappDomain?: {
                ID: string;
                Name: string;
                WeakDKIM: boolean;
                SPFVerified: boolean;
                DKIMVerified: boolean;
                ReturnPathDomainVerified: boolean;
                SPFHost?: string;
                SPFTextValue?: string;
                DKIMHost?: string;
                DKIMTextValue?: string;
                DKIMPendingHost?: string;
                DKIMPendingTextValue?: string;
                DKIMRevokedHost?: string;
                DKIMRevokedTextValue?: string;
                SafeToRemoveRevokedKeyFromDNS?: boolean;
                DKIMUpdateStatus?: "Pending" | "Verified" | "Failed";
                ReturnPathDomain?: string;
                ReturnPathDomainCNAMEValue?: string;
              };
              /** @format date-time */
              lastModified?: Date;
            };
          };
        };
        claimType: {
          id: number;
          name:
            | "FLIGHT_DELAY"
            | "FLIGHT_CANCELLATION"
            | "WRONG_ARRIVAL_AIRPORT"
            | "MISSED_CONNECTION_DUE_TO_DELAY"
            | "OVERBOOKING"
            | "COVID_ORDINANCE_2020"
            | "PNR_SEGMENT_CANCELLATION"
            | "DELAY_FROM_PNR_SCHEDULE"
            | "CONNECTION_DISRUPTION";
          isWholeFlightEligible: boolean;
          /**
           * Restricted scope of application (2 letters ISO country code)
           * @minLength 2
           * @maxLength 2
           * @example "FR"
           */
          passengerCitizenshipRequirement?: string;
        };
        claimLegalStep: {
          /**
           * @min 0
           * @max 20
           */
          id: number;
          name:
            | "CLAIM_VALIDATION"
            | "UPCLAIM"
            | "CONCILIATION"
            | "COURT"
            | "BAILIFF"
            | "CANCELLED"
            | "LOST"
            | "WAITING_FOR_MONEY"
            | "MONEY_RECEIVED"
            | "PAYMENT_SENT";
          isFinalStep: boolean;
          expectedDurationInDays: number;
          displayTextFr: string;
        };
        paymentAccount: {
          id: string;
          claimId: string;
          iban: string;
          /** @example "REVOLT21" */
          bic: string;
          /** @example "CHASDEFX" */
          intermediateBic?: string;
          /** @example "UPCLAIM" */
          beneficiary: string;
          /** @example 170 */
          beneficiaryAddressId: number;
          /** @example "FR" */
          countryCode: string;
          /** @example 0 */
          balance: number;
          /** @example "EUR" */
          currencyCode: string;
          thirdAccountId: string;
          /** @example true */
          isActive: boolean;
          /** @example 1 */
          bankId: number;
          ribFileId: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          balanceSyncedAt: Date;
          bank: {
            /** @min 1 */
            id: number;
            name: string;
            /** @min 1 */
            addressId: number;
          };
        };
        additionalRequests: {
          id: number;
          claimId: string;
          reason: string;
          additionalRequestTypeName:
            | "ARTICLE_700"
            | "PROCEDURE_COSTS"
            | "ABUSIVE_RESISTANCE"
            | "LACK_OF_INFORMATION_NOTICE";
          additionalRequestType: {
            id: number;
            type: "ARTICLE_700" | "PROCEDURE_COSTS" | "ABUSIVE_RESISTANCE" | "LACK_OF_INFORMATION_NOTICE";
            /** @example "Défaut de notice d'information" */
            displayText: string;
          };
          /**
           * In cents, 2 digits precision
           * @min 1
           * @max 9999999999999
           */
          amountRequested: number;
          /**
           * In cents, 2 digits precision
           * @min 0
           */
          amountReceived?: number;
          courtDecisionBoxFileId?: string;
          /** @format date-time */
          createdAt: Date;
        }[];
        claimExpenses: {
          id: number;
          claimId: string;
          expenseId: number;
          paidBy: string;
          userClaimId?: string;
          expense: {
            id: number;
            expenseTypeId: number;
            /** DecimalJS */
            price: string;
            /**
             * @minLength 3
             * @maxLength 3
             * @example "EUR"
             */
            currencyCode: string;
            isLostPrestation: boolean;
            expenseName?: string;
            claimDocumentId?: string;
            createdBy?: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            expenseType: {
              id: number;
              type:
                | "TRAIN"
                | "HOTEL"
                | "TAXI"
                | "OUTBOUND_FLIGHT"
                | "RETURN_FLIGHT"
                | "FOOD"
                | "PHONE_PLAN"
                | "TRAVEL_PACKAGE_SERVICE"
                | "OTHER"
                | "SALARY_COMPENSATION";
            };
            claimDocument?: {
              id: string;
              claimId: string;
              adminId: string;
              /** @min 0 */
              documentTypeId: number;
              fileId: string;
              description: string;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
              documentType: {
                /** @min 0 */
                id: number;
                type:
                  | "KBIS_UPCLAIM"
                  | "INVOICES_MERGED"
                  | "CLAIM_NOTIFICATION"
                  | "ELIGIBILITY_PROOF"
                  | "RIB_UPCLAIM"
                  | "FIRST_CONCILIATION_ATTEMPT"
                  | "MED"
                  | "MED_RECEIPT"
                  | "ESCP_A"
                  | "ESCP_B"
                  | "ESCP_C"
                  | "ESCP_D"
                  | "COURT_DECISION"
                  | "PLEADING_FILE"
                  | "OTHER"
                  | "LEGAL_SUBPOENA_SERVED"
                  | "DEBT_CONTRACT"
                  | "LEGAL_SUBPOENA_TO_REVIEW"
                  | "KBIS_OPPONENT"
                  | "ID_PROOF"
                  | "ETICKET"
                  | "DEBT_CONTRACT_ENTERPRISE"
                  | "DEBT_CONTRACT_TRAVEL_AGENCY_TO_UPCLAIM"
                  | "PROOF_OF_EXPENSE"
                  | "RECEIVABLE_TRAIL";
              };
              file: {
                id: string;
                name: string;
                size: number;
                /** @example "application/pdf" */
                mimeType: string;
                path: string;
                fileId: string;
                /** @example "1274366276920" */
                boxFileId: string;
                /** @example "1274366276920" */
                sha512: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
              };
              admin?: {
                id: string;
                tenantId: string;
                auth0Id: string;
                boxUserId: string;
                slackUserId: string;
                fullName: string;
                email: string;
                phone: string;
                isActive: boolean;
                invited: boolean;
                lawFirmId: string;
                legalContactPhone?: string;
                frontUserId?: string;
                /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
                profilePictureUrl: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
                roleId: number;
              };
            };
          };
        }[];
        claimEvents: {
          id: string;
          claimId: string;
          adminId: string;
          /** @min 0 */
          eventTypeId: number;
          /** @format date */
          eventDate: Date;
          internalNote: string;
          messageLink: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          eventType: {
            /** @min 0 */
            id: number;
            type:
              | "CLAIM_VALIDATION.CLOSE_CLAIM"
              | "CLAIM_VALIDATION.CLAIM_ELIGIBILITY_CONFIRMED"
              | "CLAIM_VALIDATION.DEBT_CONTRACT_SENT"
              | "CLAIM_VALIDATION.DEBT_SIGNED"
              | "UPCLAIM.FIRST_EMAIL_SENT"
              | "UPCLAIM.ABORTION"
              | "UPCLAIM.DISAGREE_AIRLINE_REPLY"
              | "UPCLAIM.AIRLINE_REPLY_DESERVES_FURTHER_STUDY"
              | "UPCLAIM.AIRLINE_AGREES_TO_PAY"
              | "UPCLAIM.AIRLINE_REPLY_DELAY_EXCEDEED"
              | "CONCILIATION.DISAGREE_AIRLINE_REPLY"
              | "CONCILIATION.AIRLINE_REPLY_DESERVES_FURTHER_STUDY"
              | "CONCILIATION.AIRLINE_AGREES_TO_PAY"
              | "CONCILIATION.AIRLINE_REPLY_DELAY_EXCEDEED"
              | "UPCLAIM.OUTBOUND_REPLY_SENT"
              | "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_RECEIVED"
              | "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_NOT_RECEIVED"
              | "COURT.JURIDCTION_CHOOSEN"
              | "CONCILIATION.OUTBOUND_REPLY_SENT"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_SENT_TO_AIRLINE"
              | "WAITING_FOR_MONEY.UPCLAIM_FOLLOW_UP"
              | "COURT.PROCEDURE_REPL"
              | "COURT.PROCEDURE_CLASSIQUE"
              | "COURT.PROCEDURE_BREF_DELAI"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_SIGNED_BY_AIRLINE"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_SIGNED_BY_AIRLINE"
              | "WAITING_FOR_MONEY.UPCLAIM_FOLLOW_UP_AIRLINE_AGREEMENT"
              | "WAITING_FOR_MONEY.UPCLAIM_NO_AGREEMENT_AFTER_FOLLOW_UP"
              | "COURT.ESCP_FORM_A_CHECK_NO_PLEAD"
              | "COURT.ESCP_FORM_A_CHECK_PLEAD"
              | "COURT.PROCEDURE_CLASSIQUE_DATE_SELECTED_TRIAL"
              | "COURT.BACK_TO_PROCEDURE_SELECTION"
              | "COURT.PROCEDURE_CLASSIQUE_BACK_JURIDICTION_SELECTED"
              | "COURT.PROCEDURE_CLASSIQUE_UNLOCKED_ABORTION"
              | "COURT.PROCEDURE_CLASSIQUE_UNLOCKED_AGREEMENT"
              | "COURT.BREF_DELAI_CHECK_CONCLUSIONS"
              | "COURT.BREF_DELAI_DATE_RECEIVED"
              | "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION_PAYMENT_RECEIVED"
              | "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION_PAYMENT_EXCEEDED_DELAY"
              | "WAITING_FOR_MONEY.CONCILIATION_FOLLOW_UP_SENT_WITHOUT_PROTOCOLE"
              | "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_RECEIVED_AFTER_FOLLOW_UP"
              | "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_NOT_RECEIVED_AFTER_FOLLOW_UP"
              | "COURT.ESCP_FORM_A_SENT"
              | "COURT.ESCP_GROUP_CONFIRM_SAS_TRIAL_DATE"
              | "COURT.ESCP_BACK_CHOSSEN_TRIAL"
              | "COURT.PROCEDURE_CLASSIQUE_GROUP_CONFIRM_SAS_TRIAL_DATE"
              | "COURT.PROCEDURE_CLASSIQUE_BACK_TRIAL_DATE_SELECTED"
              | "COURT.BREF_DELAI_GRANTED"
              | "COURT.BREF_DELAI_REJECTED"
              | "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION"
              | "WAITING_FOR_MONEY.CONCILIATION_FOLLOW_UP_AFTER_TRANSACTIONAL_PROTOCOL"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_RECEIVED_AFTER_FOLLOW_UP"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_RECEIVED_AFTER_FOLLOW_UP"
              | "COURT.REPL_FORM_C_RECEIVED_COURT"
              | "COURT.ESPC_FORM_B_RECEIVED"
              | "COURT.PROCEDURE_CLASSIQUE_ASSIGNATION_CONFIRM_LAWYER"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL_REFERRAL"
              | "COURT.PROCEDURE_CLASSIQUE_SIMPLE_WITHDRAWAL"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_PAID_AFTER_FOLLOW_UP"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_PAID_AFTER_FOLLOW_UP"
              | "COURT.REPL_WAITING_FOR_AIRLINE_REPLY_1"
              | "COURT.REPL_AIRLINE_REPLY_DELAY_EXCEDEED"
              | "COURT.ESCP_FORM_B_COURT_SENT"
              | "COURT.PROCEDURE_CLASSIQUE_SEND_ASSIGNATION_BAILIFF"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL_WON"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL_LOST"
              | "COURT.PROCEDURE_CLASSIQUE_AGREEMENT_LOCKED"
              | "COURT.PROCEDURE_CLASSIQUE_LOCKED_ABORTION"
              | "COURT.PROCEDURE_CLASSIQUE_LOCKED_BACK_COURT_CHOSEN"
              | "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_HOMOLOGATED_BY_COURT"
              | "COURT.ASSIGNATION_COPY_REVEIVED"
              | "COURT.AIRLINE_APPEAL"
              | "COURT.NO_AIRLINE_APPEAL"
              | "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_SENT_TO_AIRLINE"
              | "WAITING_FOR_MONEY.BAILIFF_SEIZED_AFTER_PROTOCOL_HOMOLOGATED_BY_COURT"
              | "COURT.REPL_ABORTION"
              | "COURT.REPL_AIRLINE_RIGHT_OF_REPLY_EXTENDED_EXERCISED"
              | "COURT.CLAIM_ENLISTMENT"
              | "COURT.AFTER_TRIAL_PAIEMENT_RECEIVED"
              | "COURT.AFTER_TRIAL_PAYMENT_EXCEED_DELAY"
              | "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_SIGNED_BY_AIRLINE"
              | "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_NOT_SIGNED_BY_AIRLINE"
              | "COURT.PROCEDURE_CLASSIQUE_NO_AGREEMENT_WITH_AIRLINE"
              | "BAILIFF.AFTER_TRIAL"
              | "BAILIFF.AFTER_TRIAL_PAYMENT_RECEIVED"
              | "BAILIFF.FORCED_EXECUTION"
              | "BAILIFF.PAYMENT_RECEIVED"
              | "COURT.REPL_AIRLINE_REPLY_DELAY_EXCEDEED_WITH_PLEADING"
              | "COURT.REPL_AIRLINE_RIGHT_OF_REPLY_EXTENDED_EXERCISED_WITH_PLEADING"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL_NOTIFIED_DECISION"
              | "COURT.VICTORY_AFTER_AIRLINE_APPEAL"
              | "COURT.LOST_AFTER_AIRLINE_APPEAL"
              | "CLAIM_VALIDATION.AGENT_FEEDBACK_COLLECTED"
              | "CLAIM_VALIDATION.ADDITIONAL_LOSS_COLLECTED"
              | "CONCILIATION.ABORTION"
              | "COURT.PROCEDURE_CHOICE_ABORTION"
              | "CLAIM_VALIDATION.CLAIM_CREATED"
              | "UPCLAIM.MED_SENT"
              | "CLAIM_VALIDATION.DIRECT_PASSENGERS_CONTACT_CHOOSEN"
              | "CLAIM_VALIDATION.MANUAL_PASSENGERS_CONTACT_CHOOSEN"
              | "CLAIM_VALIDATION.ALL_PASSENGERS_HAVE_SIGNED"
              | "CLAIM_VALIDATION.ALL_PASSENGERS_HAVE_SIGNED_WITH_ENTERPRISE_LOSS"
              | "CLAIM_VALIDATION.ENTEPRISE_EXPENSES_COLLECTED"
              | "CLAIM_VALIDATION.ENTEPRISE_EXPENSES_COLLECTED_EMPTY"
              | "CLAIM_VALIDATION.ENTERPRISE_HAS_SIGNED"
              | "CLAIM_VALIDATION.ENTERPRISE_SIGNATURE_EXPIRED"
              | "CLAIM_VALIDATION.DEBT_CONTRACT_SENT_B2C_AND_B2B"
              | "CLAIM_VALIDATION.PASSENGERS_DEBT_SIGNED"
              | "CLAIM_VALIDATION.PASSENGERS_AND_ENTERPRISE_DEBT_SIGNED"
              | "PAYMENT_SENT"
              | "CLAIM_VALIDATION.DEBT_CONTRACT_SENT_MANUALLY";
            /** @example "1er email envoyé" */
            displayName: string;
            machineSourceId: string;
            /** @min 0 */
            machineId: number;
            sendNotification: boolean;
            /** @min 0 */
            claimLegalStepId: number;
            description?: string;
            /** @min 0 */
            claimStateId: number;
          };
          admin?: {
            id: string;
            tenantId: string;
            auth0Id: string;
            boxUserId: string;
            slackUserId: string;
            fullName: string;
            email: string;
            phone: string;
            isActive: boolean;
            invited: boolean;
            lawFirmId: string;
            legalContactPhone?: string;
            frontUserId?: string;
            /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
            profilePictureUrl: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            roleId: number;
          };
        }[];
        claimState: {
          /** @min 0 */
          id: number;
          type:
            | "CLAIM_VALIDATION.WAIT_FOR_ELIGIBILITY_CHECK"
            | "LOST"
            | "CLAIM_VALIDATION.WAIT_FOR_PASSENGERS_EMAILS_CHECK"
            | "CLAIM_VALIDATION.WAIT_FOR_PASSENGERS_EMAILS"
            | "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_CONTRACT_SEND"
            | "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_CONTRACT_SIGNATURES"
            | "UPCLAIM.WAIT_FOR_1ST_EMAIL_SEND"
            | "UPCLAIM.WAIT_FOR_AIRLINE_REPLY"
            | "CONCILIATION.WAIT_FOR_AIRLINE_REPLY"
            | "UPCLAIM.WAIT_FOR_UPCLAIM_REPLY"
            | "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT"
            | "COURT.WAIT_FOR_JURIDCTION_CHOICE"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT)FOR_TRANSACTIONAL_PROTOCOL_GENERATION"
            | "MONEY_RECEIVED"
            | "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_FOLLOW_UP_REDACTION"
            | "COURT.WAIT_FOR_PROCEDURE_CHOICE"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT)FOR_TRANSACTIONAL_PROTOCOL_SIGNATURE"
            | "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT_FOLLOW_UP_REPLY"
            | "COURT.WAIT_FOR_ESCP_FORM_A"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_TRIAL_DATE_CHOICE"
            | "COURT.BREF_DELAI_WAIT_FOR_PRESIDENT_APPOINTMENT_REPLY"
            | "WAITING_FOR_MONEY.WAIT_FOR_CARPA_PAYMENT"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_FOLLOW_UP_WITHOUT_PROTOCOLE"
            | "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT_AFTER_FOLLOW_UP"
            | "COURT.WAIT_FOR_ESCP_FORM_A_SEND"
            | "COURT.WAIT_FOR_ESCP_GROUP"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_GROUP"
            | "COURT.BREF_DELAI_WAIT_FOR_PRESIDENT_APPOINTMENT_DATE"
            | "WAITING_FOR_MONEY.WAIT_FOR_COURT_DESISTEMENT_INSTANCE_ACTION"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_TRANSACTIONAL_PROTOCOLE_REDACTION"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_FOLLOW_UP_REPLY_WITHOUT_TRANSACTIONAL_PROTOCOLE_REPLY"
            | "COURT.WAIT_FOR_ESCP_FORM_A_COURT_RECEIPT"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_ASSIGNATION_GENERATION"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_HEARING"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_TRANSACTIONAL_PROTOCOLE_REPLY"
            | "COURT.WAIT_FOR_ESCP_FORM_C_AIRLINE_REPLY"
            | "COURT.WAIT_FOR_ESCP_FORM_B"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_BAILLIF_TRANSMISSION"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_DELIBERATE_RESULTS"
            | "COURT.WAIT_FOR_CLAIM_DESTINY"
            | "WAITING_FOR_MONEY.COURT_WAIT_FOR_TRANSACTIONAL_PROTOCOL_SEND_TO_COURT"
            | "COURT.WAIT_FOR_ESCP_FORM_C_UPCLAIM_REPLY"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_BAILLIF_UPLOAD"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_TRIAL_SIGNIFICATION"
            | "WAITING_FOR_MONEY.COURT_WAIT_FOR_FORCED_EXECUTION"
            | "WAITING_FOR_MONEY.WAITING_FOR_TRANSACTIONAL_PROTOCOL"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_ENROLMENT"
            | "COURT.WAIT_FOR_APPEAL"
            | "WAITING_FOR_MONEY.WAITING_FOR_TRANSACTIONAL_PROTOCOL_SIGNATURE"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_CALENDAR_HEARING"
            | "COURT.WAIT_FOR_APPEAL_PROCEDURE"
            | "COURT.WAIT_FOR_PAYMENT_AFTER_TRIAL_VICTORY"
            | "BAILIFF.WAIT_FOR_BAILIF_CLAIM"
            | "BAILIFF.WAIT_FOR_BAILIF_REPLY"
            | "BAILIFF.WAIT_FOR_PAYMENT_AFTER_REQUISITION"
            | "CLAIM_VALIDATION.WAIT_FOR_AGENT_FEEDBACK"
            | "CLAIM_VALIDATION.WAIT_FOR_ADDITIONAL_LOSS_FEEDBACK"
            | "CLAIM_VALIDATION.WAIT_FOR_DOCUMENTS_CREATION"
            | "UPCLAIM.WAIT_SENDS_MED"
            | "CANCELLED"
            | "CLAIM_VALIDATION.CHOICE_OF_CONTACT_MODE"
            | "CLAIM_VALIDATION.WAIT_FOR_PASSENGER_YOUSIGN_SIGNATURE"
            | "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_TRAVEL_AGENCY"
            | "CLAIM_VALIDATION.WAIT_FOR_ENTERPRISE_ADDITIONAL_LOSS"
            | "CLAIM_VALIDATION.WAIT_FOR_ENTREPRISE_SIGNATURE"
            | "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_CONTRACT_SIGNATURES_B2C_AND_B2B"
            | "PAYMENT_SENT";
          /** @example "Attente vérification éligibilité" */
          displayName: string;
          description?: string;
          machineSourceId: string;
          entryAction?: string;
          expectedDurationInDays: number;
          /** @min 0 */
          legalStepId: number;
        };
        agentFeedback: {
          id: string;
          sentToAdminId: string;
          claimId: string;
          validationOptionId: number;
          /** @format date-time */
          lastModified: Date;
          /** @format date-time */
          createdAt?: Date;
          note: string;
          b2c: boolean;
          additionalLoss?: string;
          admin: {
            id: string;
            tenantId: string;
            auth0Id: string;
            boxUserId: string;
            slackUserId: string;
            fullName: string;
            email: string;
            phone: string;
            isActive: boolean;
            invited: boolean;
            lawFirmId: string;
            legalContactPhone?: string;
            frontUserId?: string;
            /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
            profilePictureUrl: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            roleId: number;
          };
          validationOption: {
            id: number;
            claimTypeId: number;
            name: string;
            description: string;
            eligible: boolean;
          };
          /** @format date-time */
          additionalLossRequestSentAt?: Date;
        };
        claimDocuments: {
          id: string;
          claimId: string;
          adminId: string;
          /** @min 0 */
          documentTypeId: number;
          fileId: string;
          description: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          documentType: {
            /** @min 0 */
            id: number;
            type:
              | "KBIS_UPCLAIM"
              | "INVOICES_MERGED"
              | "CLAIM_NOTIFICATION"
              | "ELIGIBILITY_PROOF"
              | "RIB_UPCLAIM"
              | "FIRST_CONCILIATION_ATTEMPT"
              | "MED"
              | "MED_RECEIPT"
              | "ESCP_A"
              | "ESCP_B"
              | "ESCP_C"
              | "ESCP_D"
              | "COURT_DECISION"
              | "PLEADING_FILE"
              | "OTHER"
              | "LEGAL_SUBPOENA_SERVED"
              | "DEBT_CONTRACT"
              | "LEGAL_SUBPOENA_TO_REVIEW"
              | "KBIS_OPPONENT"
              | "ID_PROOF"
              | "ETICKET"
              | "DEBT_CONTRACT_ENTERPRISE"
              | "DEBT_CONTRACT_TRAVEL_AGENCY_TO_UPCLAIM"
              | "PROOF_OF_EXPENSE"
              | "RECEIVABLE_TRAIL";
          };
          file: {
            id: string;
            name: string;
            size: number;
            /** @example "application/pdf" */
            mimeType: string;
            path: string;
            fileId: string;
            /** @example "1274366276920" */
            boxFileId: string;
            /** @example "1274366276920" */
            sha512: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
          };
          admin?: {
            id: string;
            tenantId: string;
            auth0Id: string;
            boxUserId: string;
            slackUserId: string;
            fullName: string;
            email: string;
            phone: string;
            isActive: boolean;
            invited: boolean;
            lawFirmId: string;
            legalContactPhone?: string;
            frontUserId?: string;
            /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
            profilePictureUrl: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            roleId: number;
          };
        }[];
        conversation: {
          id: string;
          claimId?: string;
          inboxId?: string;
          /** @example "cnv_ibc6p1m" */
          frontConversationId: string;
          /** @format date-time */
          lastMessageReceivedOn: Date;
          /** @format date-time */
          lastMessageSentOn: Date;
          /** @format date-time */
          createdAt: Date;
        };
        machine: {
          /** @min 1 */
          id: number;
          /** @example "AIR_LITIGATION" */
          litigationName: "AIR_LITIGATION";
          /** @min 1 */
          versionNumber: number;
          versionDescription?: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified?: Date;
        };
        attachments: {
          id: string;
          name: string;
          size: number;
          type: string;
          sender: string;
          claimId: string;
          frontAttachmentId: string;
          /** @format date */
          createdAt: Date;
        }[];
        usersClaimsFamilies: {
          id: string;
          claimId: string;
          familyName: string;
          signerFullname?: string;
          /** For communicating with the family (signature request, events, etc) */
          email: string;
        }[];
        signatures: {
          id: string;
          /** @default "YOUSIGN" */
          service?: "YOUSIGN" | "BOX";
          thirdId: string;
          signatureFileId?: string;
          signatureTrailFileId?: string;
          /** @default "PENDING" */
          status?: "PENDING" | "COMPLETED" | "EXPIRED" | "DECLINED";
          /** @format date-time */
          statusUpdatedAt?: Date;
          claimId: string;
          /** @min 0 */
          totalAmountEuro: number;
          signatureType: "PASSENGER" | "ENTERPRISE" | "TRAVEL_AGENCY";
          signerEmail: string;
          ccEmails?: string;
          /** @format date-time */
          expirationDate?: Date;
          sequenceId?: string;
          declineReason?: string;
          /** @format date-time */
          createdAt?: Date;
        }[];
        usersClaims: {
          id: string;
          userId: string;
          userFlightId?: string;
          claimId: string;
          familyId: string;
          /** @min 1 */
          abortionId: number;
          /** @min 1 */
          legalDocumentsId: number;
          /** If White Label is set, we do not exist for the passengers:      No direct email, SMS or even Dashboard access for them */
          isWhiteLabel: boolean;
          /** Soft delete (Because of declined signature, etc */
          isRemoved: boolean;
          /**
           * Flight compensation amount as per Montreal Convention
           * @example 1250.89
           */
          montrealConventionCompensationAmount?: string;
          /** To prevent side-effects when creating manual claims */
          email: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          ticketImage: {
            /** @example "clmhjnjkd0006ye2yvkw2sl83" */
            id: string;
            /** @example "220-1026034047-49" */
            ticketNumber: string;
            lastImage?: string;
            beforeCancellationImage?: string;
            /** @example "Eric" */
            firstName: string;
            /** @example "Dupont" */
            lastName: string;
            userClaimId: string;
            /** @min 1 */
            segmentId: number;
            /** @format date-time */
            createdAt: Date;
          };
          user: {
            id: string;
            /** @example "Eric" */
            firstName: string;
            /** @example "Dupont" */
            lastName: string;
            /** @example "DUPONT/ERIC" */
            rawGdsName?: string;
            /** @example "eric.dupont@gmail.com" */
            email: string;
            /** @example "+33642424242" */
            phone: string;
            /**
             * 2 letters ISO country code
             * @minLength 2
             * @maxLength 2
             * @example "FR"
             */
            nationalityCountryCode: string;
            /** @format date */
            birthdate: Date;
            /**
             * ISO/IEC 5218: 1 for male, 2 for female
             * @min 0
             * @max 9
             */
            civility: number;
            /** @min 1 */
            postalAddressId?: number;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
          };
          expenses: {
            id: number;
            userClaimId: string;
            expenseId: number;
            expense: {
              id: number;
              expenseTypeId: number;
              /** DecimalJS */
              price: string;
              /**
               * @minLength 3
               * @maxLength 3
               * @example "EUR"
               */
              currencyCode: string;
              isLostPrestation: boolean;
              expenseName?: string;
              claimDocumentId?: string;
              createdBy?: string;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
              expenseType: {
                id: number;
                type:
                  | "TRAIN"
                  | "HOTEL"
                  | "TAXI"
                  | "OUTBOUND_FLIGHT"
                  | "RETURN_FLIGHT"
                  | "FOOD"
                  | "PHONE_PLAN"
                  | "TRAVEL_PACKAGE_SERVICE"
                  | "OTHER"
                  | "SALARY_COMPENSATION";
              };
              claimDocument?: {
                id: string;
                claimId: string;
                adminId: string;
                /** @min 0 */
                documentTypeId: number;
                fileId: string;
                description: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
                documentType: {
                  /** @min 0 */
                  id: number;
                  type:
                    | "KBIS_UPCLAIM"
                    | "INVOICES_MERGED"
                    | "CLAIM_NOTIFICATION"
                    | "ELIGIBILITY_PROOF"
                    | "RIB_UPCLAIM"
                    | "FIRST_CONCILIATION_ATTEMPT"
                    | "MED"
                    | "MED_RECEIPT"
                    | "ESCP_A"
                    | "ESCP_B"
                    | "ESCP_C"
                    | "ESCP_D"
                    | "COURT_DECISION"
                    | "PLEADING_FILE"
                    | "OTHER"
                    | "LEGAL_SUBPOENA_SERVED"
                    | "DEBT_CONTRACT"
                    | "LEGAL_SUBPOENA_TO_REVIEW"
                    | "KBIS_OPPONENT"
                    | "ID_PROOF"
                    | "ETICKET"
                    | "DEBT_CONTRACT_ENTERPRISE"
                    | "DEBT_CONTRACT_TRAVEL_AGENCY_TO_UPCLAIM"
                    | "PROOF_OF_EXPENSE"
                    | "RECEIVABLE_TRAIL";
                };
                file: {
                  id: string;
                  name: string;
                  size: number;
                  /** @example "application/pdf" */
                  mimeType: string;
                  path: string;
                  fileId: string;
                  /** @example "1274366276920" */
                  boxFileId: string;
                  /** @example "1274366276920" */
                  sha512: string;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified: Date;
                };
                admin?: {
                  id: string;
                  tenantId: string;
                  auth0Id: string;
                  boxUserId: string;
                  slackUserId: string;
                  fullName: string;
                  email: string;
                  phone: string;
                  isActive: boolean;
                  invited: boolean;
                  lawFirmId: string;
                  legalContactPhone?: string;
                  frontUserId?: string;
                  /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
                  profilePictureUrl: string;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified: Date;
                  roleId: number;
                };
              };
            };
          }[];
          userSegment: {
            /** @min 1 */
            id: number;
            userId: string;
            /** @min 1 */
            segmentId: number;
            userClaimId: string;
            rawTicketCiphered?: string;
            ticketNumber: string;
            /** @format date-time */
            ticketSyncedAt: Date;
            /** @format date-time */
            ticketIssueDate: Date;
            involuntaryIndicator: boolean;
            ticketLegStatus: string[];
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            ticket_leg_id?: string;
            segment?: {
              reservation: {
                /** @example "MBZ24G" */
                gdsPnrId: string;
                /** @format date-time */
                pnrCreatedAt: Date;
              };
              flight: {
                /**
                 * @minLength 3
                 * @maxLength 8
                 * @example "AF80"
                 */
                flightIdentifier: string;
                isCodeshare: boolean;
                airline: {
                  name: string;
                  /**
                   * @minLength 2
                   * @maxLength 3
                   * @example "AF"
                   */
                  iata: string;
                  /**
                   * @maxLength 3
                   * @example "AFR"
                   */
                  icao?: string;
                };
              };
            };
          };
        }[];
        legalSpecification: {
          id: string;
          claimId: string;
          airlineId: string;
          effectiveFlightId: string;
          /**
           * Flight compensation amount under EU 261/2004 regulation
           * @min 0
           * @max 600
           */
          ec261CompensationAmount: number;
          /** @min 1 */
          impactedSegmentId: number;
          /**
           * Wether the ticket should be refunded or not, in addition of having the compensation
           * @default false
           */
          shouldTicketBeRefunded: boolean;
          /**
           * @min 0
           * @max 100
           */
          b2cCommissionPercentageForUpclaim: number;
          /**
           * @min 0
           * @max 100
           */
          b2cCommissionPercentageForTravelAgency: number;
          /**
           * @min 0
           * @max 100
           */
          b2bCommissionPercentageForUpclaim: number;
          /**
           * @min 0
           * @max 100
           */
          b2bCommissionPercentageForTravelAgency: number;
          /**
           * @min 0
           * @max 100
           */
          travelAgencyLossCommissionPercentageForUpclaim: number;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          impactedSegment: {
            /** @min 1 */
            id: number;
            uuid: string;
            flightId: string;
            reservationId: string;
            /** @min 1 */
            segmentNumber?: number;
            /** @example "AIRLINE" */
            cancelledBy?: "AIRLINE" | "CUSTOMER";
            /** @example "RECORD" */
            cancellationType?: "SEGMENT" | "RECORD";
            /** @format date-time */
            cancellationDate?: Date;
            cancellationSignature?: string;
            /** @min 1 */
            actualReroutingId: number;
            initialRecordNumber: number;
            /** Segment can have many Tickets (passengers). However, we take 1 from the reservation, as a reference for operation & computations (segment grouping etc). */
            referenceTicketNumber: string;
            /** @format date-time */
            syncDate: Date;
            /** @format date-time */
            legalScheduledDepartureUTC?: Date;
            /** @format date-time */
            legalScheduledArrivalUTC?: Date;
            /** @format date-time */
            confirmationDate: Date;
            /** @example "NOSHOW" */
            remarks?: string;
            waitlistIndicator: boolean;
            /** @min 1 */
            legNumber: number;
            /** @min 1 */
            seatNumber: number;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            /** @minItems 0 */
            reroutingProposals: {
              id: number;
              impactedSegmentId: number;
              proposedSegmentId: number;
              stopoverNumber?: number;
              reroutingGroupId: number;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified?: Date;
              reroutingGroup: {
                id: number;
                reroutings: {
                  id: number;
                  impactedSegmentId: number;
                  proposedSegmentId: number;
                  stopoverNumber?: number;
                  reroutingGroupId: number;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified?: Date;
                  proposedSegment: {
                    /** @min 1 */
                    id: number;
                    uuid: string;
                    flightId: string;
                    reservationId: string;
                    /** @min 1 */
                    segmentNumber?: number;
                    /** @example "AIRLINE" */
                    cancelledBy?: "AIRLINE" | "CUSTOMER";
                    /** @example "RECORD" */
                    cancellationType?: "SEGMENT" | "RECORD";
                    /** @format date-time */
                    cancellationDate?: Date;
                    cancellationSignature?: string;
                    /** @min 1 */
                    actualReroutingId: number;
                    initialRecordNumber: number;
                    /** Segment can have many Tickets (passengers). However, we take 1 from the reservation, as a reference for operation & computations (segment grouping etc). */
                    referenceTicketNumber: string;
                    /** @format date-time */
                    syncDate: Date;
                    /** @format date-time */
                    legalScheduledDepartureUTC?: Date;
                    /** @format date-time */
                    legalScheduledArrivalUTC?: Date;
                    /** @format date-time */
                    confirmationDate: Date;
                    /** @example "NOSHOW" */
                    remarks?: string;
                    waitlistIndicator: boolean;
                    /** @min 1 */
                    legNumber: number;
                    /** @min 1 */
                    seatNumber: number;
                    /** @format date-time */
                    createdAt: Date;
                    /** @format date-time */
                    lastModified: Date;
                    flight: {
                      id: string;
                      airlineId: string;
                      departureAirportId: string;
                      arrivalAirportId: string;
                      effectiveFlightId: string;
                      diversionAirportId: string;
                      /** @example "3196fe6900db41898cfa693f6ebe545f" */
                      flightTrackingGuid?: string;
                      distanceInkm: number;
                      /**
                       * @minLength 3
                       * @maxLength 8
                       * @example "AF80"
                       */
                      flightIdentifier: string;
                      /** @format date-time */
                      scheduledDepartureUTC: Date;
                      /** @format date */
                      scheduledDepartureLocal: Date;
                      /** @format date-time */
                      scheduledArrivalUTC: Date;
                      /** @format date */
                      scheduledArrivalLocal: Date;
                      /** @format date-time */
                      inGateArrivalUTC?: Date;
                      /** @format date */
                      inGateArrivalLocal?: Date;
                      /** @format date-time */
                      actualDepartureUTC?: Date;
                      /** @format date */
                      actualDepartureLocal?: Date;
                      /** @example "2E" */
                      departureTerminal?: string;
                      /** @example "A" */
                      arrivalTerminal?: string;
                      /** @format date-time */
                      checkinDateUTC?: Date;
                      monitoringStatus?: string;
                      isCodeshare: boolean;
                      operatingAirlineId: string;
                      /** @format date-time */
                      createdAt: Date;
                      /** @format date-time */
                      lastModified: Date;
                      airline: {
                        name: string;
                        /**
                         * @minLength 2
                         * @maxLength 3
                         * @example "AF"
                         */
                        iata: string;
                        /**
                         * @maxLength 3
                         * @example "AFR"
                         */
                        icao?: string;
                        /** Is the airline under the 261/2004 regulation */
                        isEC261: boolean;
                        legalData?: {
                          iconURL?: string;
                        };
                      };
                      departureAirport: {
                        /** Is the airport under the 261/2004 regulation */
                        isEC261: boolean;
                        /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
                        name: string;
                        /**
                         * @minLength 2
                         * @maxLength 3
                         * @example "CDG"
                         */
                        iata: string;
                        /** @example "Europe/Paris" */
                        timezone: string;
                        city: string;
                      };
                      arrivalAirport: {
                        /** Is the airport under the 261/2004 regulation */
                        isEC261: boolean;
                        /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
                        name: string;
                        /**
                         * @minLength 2
                         * @maxLength 3
                         * @example "CDG"
                         */
                        iata: string;
                        /** @example "Europe/Paris" */
                        timezone: string;
                        city: string;
                      };
                    };
                  };
                }[];
              };
            }[];
            actualRerouting?: string;
            reservation: {
              id: string;
              /** @min 1 */
              gdsId: number;
              /** @min 1 */
              officeId: number;
              /** @example "MBZ24G" */
              gdsPnrId: string;
              upclaimContactEmail: string;
              journeyHistory?: string;
              /** @format date-time */
              pnrCreatedAt: Date;
              /** @format date-time */
              syncDate?: Date;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
              travelAgencyOffice: {
                id: number;
                travelAgencyId: string;
                amadeusOfficeId: string;
                /** @format date */
                lastImportDate?: Date;
                name?: string;
                /** @format date */
                createdAt: Date;
                /** @format date */
                lastModified?: Date;
                fallbackAgentEmail?: string;
                fallbackAccountManagerEmail?: string;
                isBusinessTravel: boolean;
                isDirectPassengerContactAllowed?: boolean;
              };
              travelAgencyCompany: {
                id: string;
                travelAgencyId: string;
                companyId: string;
                /** @example "radiofrance.fr" */
                domain: string;
                /** @example "Radio France" */
                displayName: string;
                /** @example "RADIO FRANCE" */
                rawGdsName: string;
                iconUrl: string;
                mainContactEmail: string;
                defaultTravelAgentAdminId: string;
                accountManagerId: string;
                bluebizIdentifier?: string;
                isDirectPassengerContactAllowed: boolean;
                passengersSignaturesForwardEmail: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
              };
              travelAgencyAgent: {
                id: string;
                adminId: string;
                gdsSignature: string;
                travelAgencyId: string;
                isDirectPassengerContactAllowed: boolean;
                isBusinessTravelAgent: boolean;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
                admin: {
                  id: string;
                  tenantId: string;
                  auth0Id: string;
                  boxUserId: string;
                  slackUserId: string;
                  fullName: string;
                  email: string;
                  phone: string;
                  isActive: boolean;
                  invited: boolean;
                  lawFirmId: string;
                  legalContactPhone?: string;
                  frontUserId?: string;
                  /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
                  profilePictureUrl: string;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified: Date;
                  roleId: number;
                };
              };
            };
          };
          effectiveAirline: {
            name: string;
            /**
             * @minLength 2
             * @maxLength 3
             * @example "AF"
             */
            iata: string;
            /**
             * @maxLength 3
             * @example "AFR"
             */
            icao?: string;
            /** Is the airline under the 261/2004 regulation */
            isEC261: boolean;
            legalData: {
              id: string;
              airlineId: string;
              companyId: string;
              legalContactEmail: string;
              personalLegalContactEmail: string;
              legalContactPhone?: string;
              /**
               * 2 letters ISO country code
               * @minLength 2
               * @maxLength 2
               * @example "FR"
               */
              nationalityCountryCode: string;
              RCS: string;
              iconURL: string;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
            };
          };
          effectiveFlight: {
            id: string;
            airlineId: string;
            departureAirportId: string;
            arrivalAirportId: string;
            effectiveFlightId: string;
            diversionAirportId: string;
            /** @example "3196fe6900db41898cfa693f6ebe545f" */
            flightTrackingGuid?: string;
            distanceInkm: number;
            /**
             * @minLength 3
             * @maxLength 8
             * @example "AF80"
             */
            flightIdentifier: string;
            /** @format date-time */
            scheduledDepartureUTC: Date;
            /** @format date */
            scheduledDepartureLocal: Date;
            /** @format date-time */
            scheduledArrivalUTC: Date;
            /** @format date */
            scheduledArrivalLocal: Date;
            /** @format date-time */
            inGateArrivalUTC?: Date;
            /** @format date */
            inGateArrivalLocal?: Date;
            /** @format date-time */
            actualDepartureUTC?: Date;
            /** @format date */
            actualDepartureLocal?: Date;
            /** @example "2E" */
            departureTerminal?: string;
            /** @example "A" */
            arrivalTerminal?: string;
            /** @format date-time */
            checkinDateUTC?: Date;
            monitoringStatus?: string;
            isCodeshare: boolean;
            operatingAirlineId: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            airline: {
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "AF"
               */
              iata: string;
              /**
               * @maxLength 3
               * @example "AFR"
               */
              icao?: string;
              /** Is the airline under the 261/2004 regulation */
              isEC261: boolean;
              legalData?: {
                id: string;
                airlineId: string;
                companyId: string;
                legalContactEmail: string;
                personalLegalContactEmail: string;
                legalContactPhone?: string;
                /**
                 * 2 letters ISO country code
                 * @minLength 2
                 * @maxLength 2
                 * @example "FR"
                 */
                nationalityCountryCode: string;
                RCS: string;
                iconURL: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
              };
            };
            departureAirport: {
              /** Is the airport under the 261/2004 regulation */
              isEC261: boolean;
              /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "CDG"
               */
              iata: string;
              /** @example "Europe/Paris" */
              timezone: string;
              /** @example "Paris" */
              city: string;
              frTranslation?: string;
            };
            arrivalAirport: {
              /** Is the airport under the 261/2004 regulation */
              isEC261: boolean;
              /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "CDG"
               */
              iata: string;
              /** @example "Europe/Paris" */
              timezone: string;
              /** @example "Paris" */
              city: string;
              frTranslation?: string;
            };
          };
        };
      },
      any
    >({
      path: `/admin/claims/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name UpdateClaim
   * @summary Update a specific claim (schedule, amounts, type, etc)
   * @request PATCH:/admin/claims/{id}
   * @secure
   */
  updateClaim = (
    id: string,
    body: {
      schedule?: {
        /** @example "25/07/2023 19:00" */
        scheduledDepartureLocal?: string;
        /** @example "25/07/2023 23:00" */
        actualDepartureLocal?: string;
        /** @example "26/07/2023 07:00" */
        scheduledArrivalLocal?: string;
        /** @example "26/07/2023 10:30" */
        inGateArrivalLocal?: string;
      };
      legalSpecification?: {
        claimTypeName?: {
          label: string;
          value: string;
        };
        ec261CompensationAmount?: {
          label: string;
          value: string;
        };
        article700Amount?: {
          amount: number;
          currency: string;
          precision: 2;
        };
        abusiveResistanceAmount?: {
          amount: number;
          currency: string;
          precision: 2;
        };
        lackOfNoticeAmount?: {
          amount: number;
          currency: string;
          precision: 2;
        };
        procedureCosts?: {
          amount: number;
          currency: string;
          precision: 2;
        };
        /** @minItems 0 */
        usersClaims?: {
          amount: number;
          currency: string;
          precision: 2;
          userClaimId: string;
        }[];
        effectiveAirline?: {
          id?: string;
          /**
           * @minLength 2
           * @maxLength 3
           * @example "AF"
           */
          iata?: string;
          /**
           * @maxLength 3
           * @example "AFR"
           */
          icao?: string;
        };
        /** @example "cnv_ibc6p1m" */
        rootFrontConversationId?: string;
      };
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}`,
      method: "PATCH",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveCompany
   * @summary Retrieve a company detail
   * @request GET:/admin/companies/{id}
   * @secure
   */
  retrieveCompany = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        id: string;
        /** @example "Upclaim" */
        name: string;
        /**
         * @pattern ^[0-9]{9}$
         * @example "890120587"
         */
        siren: string;
        /**
         * @pattern ^[0-9]{14}$
         * @example "89012058700021"
         */
        siret: string;
        /**
         * @pattern ^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$
         * @example "ATU72316013"
         */
        euVAT: string;
        /** @example "upclaim.eu" */
        domain?: string;
        logoUrl?: string;
        pappersData?: string;
        boxFolderId?: string;
        kbisBoxFileId?: string;
        /** @format date-time */
        pappersDataSyncedAt: Date;
        postalAddressId?: number;
        /** Tribunal de commerce en fonction du siège de la société */
        competentCourtId?: number;
        /**
         * Pour override celles générées à partir des Pappers data
         * @example "UPCLAIM, société par actions simplifiée au capital social de 1500 €, dont le siège social est situé au 88 BD VOLTAIRE 75011 PARIS 11, immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 890 120 587, représentée par M. Victor Boinet agissant et ayant les pouvoirs nécessaires en tant que président."
         */
        legalNotices?: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        lastModified: Date;
        postalAddress?: {
          /** @min 1 */
          id: number;
          /** Address label description */
          label?: string;
          nameLine?: string;
          /** @example "34 rue de l'Echiquier" */
          streetAddress: string;
          streetAddressComplement?: string;
          /** @example "Paris" */
          city: string;
          /** @example "75010" */
          zipCode: string;
          /** @example "Île-de-France" */
          region: string;
          /**
           * @minLength 2
           * @maxLength 2
           * @example "FR"
           */
          countryCode: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          updatedAt?: Date;
        };
        juridiction?: {
          /** @min 1 */
          id: number;
          /** @example "Tribunal judiciaire Paris" */
          name: string;
          /** @min 1 */
          postalAddressId: number;
          /** @example 6401 */
          code: number;
          /** @example "www.greffe-tc-dax.fr" */
          website: string;
          /** @example "09h-12h/14h-17h" */
          schedule: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
      },
      any
    >({
      path: `/admin/companies/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveFile
   * @summary Retrieve any file : Return a secured signed URL
   * @request GET:/admin/files/{id}
   * @secure
   */
  retrieveFile = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/files/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name GetUpclaimKpIs
   * @summary Retrieve Upclaim's KPIs
   * @request GET:/admin/reporting/KPIs
   * @secure
   */
  getUpclaimKPIs = (params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/reporting/KPIs`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name GetScopedKey
   * @summary Generate a scoped key for the search engine
   * @request GET:/admin/search/key
   * @secure
   */
  getScopedKey = (params: RequestParams = {}) =>
    this.request<
      {
        securedApiKey: string;
        /** Unix timestamp */
        validUntil?: number;
        filters: string;
      },
      any
    >({
      path: `/admin/search/key`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveCurrentTenant
   * @summary Retrieve the current tenant details
   * @request GET:/admin/tenants/current
   * @secure
   */
  retrieveCurrentTenant = (params: RequestParams = {}) =>
    this.request<
      {
        id: string;
        /** @example "Upclaim" */
        name: string;
        tenantType: "TRAVEL_AGENCY" | "ENTERPRISE" | "LAW_FIRM" | "UPCLAIM";
        /** @example "upclaim.eu" */
        domain: string;
        email: string;
        companyId: string;
        brandingId: string;
        /** @format date-time */
        createdAt: Date;
        tenantBranding?: {
          id: string;
          tenantId: string;
          logoUrl: string;
          iconUrl?: string;
          primaryColorHex?: string;
          secondaryColorHex?: string;
          backgroundColorHex?: string;
          twRadiusType?: string;
          signatureBoxUserId: string;
          /** @example "signature.upclaim.eu" */
          subdomainUri: string;
          activeCNAME: boolean;
          emailForPassengerContact?: string;
          whitelabelInboxId?: string;
          yousignWorkspaceId?: string;
          yousignExperienceId?: string;
          senderName?: string;
          replyTo?: string;
          postmarkappDomainId?: string;
          postmarkServerId?: string;
          additionalLogos: string[];
          postmarkappDomain?: {
            ID: string;
            Name: string;
            WeakDKIM: boolean;
            SPFVerified: boolean;
            DKIMVerified: boolean;
            ReturnPathDomainVerified: boolean;
            SPFHost?: string;
            SPFTextValue?: string;
            DKIMHost?: string;
            DKIMTextValue?: string;
            DKIMPendingHost?: string;
            DKIMPendingTextValue?: string;
            DKIMRevokedHost?: string;
            DKIMRevokedTextValue?: string;
            SafeToRemoveRevokedKeyFromDNS?: boolean;
            DKIMUpdateStatus?: "Pending" | "Verified" | "Failed";
            ReturnPathDomain?: string;
            ReturnPathDomainCNAMEValue?: string;
          };
          /** @format date-time */
          lastModified?: Date;
        };
        tenantOnboarding?: {
          id: string;
          tenantId: string;
          currentStepId: string;
          /** @format date-time */
          completedAt?: Date;
          steps?: {
            id: string;
            tenantOnboardingId: string;
            step?:
              | "LEGAL_ASSETS"
              | "DOMAIN"
              | "SIGNATURE"
              | "CLAIM_VALIDATION"
              | "OPT_ADD_EXPENSE"
              | "OPT_INVITE_ADMIN"
              | "OPT_CREATE_ENTERPRISE"
              | "OPT_CREATE_CLAIM";
            /** @format date-time */
            completedAt?: Date;
            data?: string;
          }[];
          currentStep?: {
            id: string;
            tenantOnboardingId: string;
            step?:
              | "LEGAL_ASSETS"
              | "DOMAIN"
              | "SIGNATURE"
              | "CLAIM_VALIDATION"
              | "OPT_ADD_EXPENSE"
              | "OPT_INVITE_ADMIN"
              | "OPT_CREATE_ENTERPRISE"
              | "OPT_CREATE_CLAIM";
            /** @format date-time */
            completedAt?: Date;
            data?: string;
          };
        };
      },
      any
    >({
      path: `/admin/tenants/current`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListClaimGroups
   * @summary List specified claim's group(s)
   * @request GET:/admin/claims/{id}/groups
   * @secure
   */
  listClaimGroups = (id: string, params: RequestParams = {}) =>
    this.request<ListClaimGroups, any>({
      path: `/admin/claims/${id}/groups`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListBusinessTravelCompaniesForClaim
   * @summary List business travel companies available to be attached to a claim
   * @request GET:/admin/claims/{id}/business-travel-companies
   * @secure
   */
  listBusinessTravelCompaniesForClaim = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        travelAgencyCompanies: {
          id: string;
          travelAgencyId: string;
          companyId: string;
          /** @example "radiofrance.fr" */
          domain: string;
          /** @example "Radio France" */
          displayName: string;
          /** @example "RADIO FRANCE" */
          rawGdsName: string;
          iconUrl: string;
          mainContactEmail: string;
          defaultTravelAgentAdminId: string;
          accountManagerId: string;
          bluebizIdentifier?: string;
          isDirectPassengerContactAllowed: boolean;
          passengersSignaturesForwardEmail: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        }[];
      },
      any
    >({
      path: `/admin/claims/${id}/business-travel-companies`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name CreateTravelAgencyCompanyFromClaim
   * @summary Create a business travel company
   * @request POST:/admin/claims/{id}/business-travel-companies
   * @secure
   */
  createTravelAgencyCompanyFromClaim = (
    id: string,
    body: {
      /** @minLength 1 */
      displayName?: string;
      domain: string;
      iconUrl?: string;
      mainContactEmail?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/business-travel-companies`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SetTravelAgencyCompanyForClaim
   * @summary Set the business travel company of a claim
   * @request PATCH:/admin/claims/{id}/business-travel-companies
   * @secure
   */
  setTravelAgencyCompanyForClaim = (
    id: string,
    body: {
      travelAgencyCompanyId?: string;
      unset?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/business-travel-companies`,
      method: "PATCH",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Used to send the confirmation form to the right agent.
   *
   * @tags Admin
   * @name RetrieveClaimContactEmails
   * @summary Retrieve a specific claim agents details
   * @request GET:/admin/claims/{id}/emails
   * @secure
   */
  retrieveClaimContactEmails = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        companyEmail?: string;
        reservationAgentEmail?: string;
        fallbackOfficeEmail: string;
        accountManagerEmail?: string;
      },
      any
    >({
      path: `/admin/claims/${id}/emails`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveClaimFormalNotice
   * @summary Retrieve a claim's formal notice
   * @request GET:/admin/claims/{id}/formal-notice
   * @secure
   */
  retrieveClaimFormalNotice = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/claims/${id}/formal-notice`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListClaimFamilies
   * @summary Fetch claim's  families (with their UserClaim & User)
   * @request GET:/admin/claims/{id}/families
   * @secure
   */
  listClaimFamilies = (id: string, params: RequestParams = {}) =>
    this.request<ClaimFamilies, any>({
      path: `/admin/claims/${id}/families`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveClaimConfidenceScore
   * @summary Retrieve a claim's confidence score
   * @request GET:/admin/claims/{id}/confidence-score
   * @secure
   */
  retrieveClaimConfidenceScore = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        confirmedBy: "UPCLAIM" | "TRAVEL_AGENCY" | "PASSENGER";
        monitoringStatus: string;
        impactedTicketLegId?: string;
        seatNumber?: number;
        cancellationCommit: {
          segmentCancellationType: string;
          signature: string;
          /** @format date */
          date: Date;
        };
        waitlistIndicator?: boolean;
        isB2B: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/confidence-score`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveLegalSubpeona
   * @summary Retrieve a claim's legal subpeona
   * @request GET:/admin/claims/{id}/legal-subpeona
   * @secure
   */
  retrieveLegalSubpeona = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/claims/${id}/legal-subpeona`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveClaimHistory
   * @summary Retrieve a claim's historical data
   * @request GET:/admin/claims/{id}/history
   * @secure
   */
  retrieveClaimHistory = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/claims/${id}/history`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListTravelAgencyAgentsForClaim
   * @summary List travel agency agents available to be assigned to a claim
   * @request GET:/admin/claims/{id}/travel-agency-agents
   * @secure
   */
  listTravelAgencyAgentsForClaim = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        admins?: {
          id: string;
          tenantId: string;
          auth0Id: string;
          boxUserId: string;
          slackUserId: string;
          fullName: string;
          email: string;
          phone: string;
          isActive: boolean;
          invited: boolean;
          lawFirmId: string;
          legalContactPhone?: string;
          frontUserId?: string;
          /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
          profilePictureUrl: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          roleId: number;
        }[];
      },
      any
    >({
      path: `/admin/claims/${id}/travel-agency-agents`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SetTravelAgencyAgentForClaim
   * @summary Set the travel agency agent of a claim
   * @request PATCH:/admin/claims/{id}/travel-agency-agents
   * @secure
   */
  setTravelAgencyAgentForClaim = (
    id: string,
    body: {
      adminId?: string;
      unset?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/travel-agency-agents`,
      method: "PATCH",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListCompetentCourtsForClaim
   * @summary List competent court(s) for specified claim
   * @request GET:/admin/claims/{id}/competent-courts
   * @secure
   */
  listCompetentCourtsForClaim = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        departureAirport: {
          /** @min 1 */
          id: number;
          /** @example "Tribunal judiciaire Paris" */
          name: string;
          /** @min 1 */
          postalAddressId: number;
          /** @example 6401 */
          code: number;
          /** @example "www.greffe-tc-dax.fr" */
          website: string;
          /** @example "09h-12h/14h-17h" */
          schedule: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
        arrivalAirport: {
          /** @min 1 */
          id: number;
          /** @example "Tribunal judiciaire Paris" */
          name: string;
          /** @min 1 */
          postalAddressId: number;
          /** @example 6401 */
          code: number;
          /** @example "www.greffe-tc-dax.fr" */
          website: string;
          /** @example "09h-12h/14h-17h" */
          schedule: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
        airline: {
          /** @min 1 */
          id: number;
          /** @example "Tribunal judiciaire Paris" */
          name: string;
          /** @min 1 */
          postalAddressId: number;
          /** @example 6401 */
          code: number;
          /** @example "www.greffe-tc-dax.fr" */
          website: string;
          /** @example "09h-12h/14h-17h" */
          schedule: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
        all: {
          /** @min 1 */
          id: number;
          /** @example "Tribunal judiciaire Paris" */
          name: string;
          /** @min 1 */
          postalAddressId: number;
          /** @example 6401 */
          code: number;
          /** @example "www.greffe-tc-dax.fr" */
          website: string;
          /** @example "09h-12h/14h-17h" */
          schedule: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        }[];
      },
      any
    >({
      path: `/admin/claims/${id}/competent-courts`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListReceivableContracts
   * @summary List receivable contracts with their signature status
   * @request GET:/admin/claims/{id}/receivable-contracts
   * @secure
   */
  listReceivableContracts = (id: string, params: RequestParams = {}) =>
    this.request<ReceivableContractsStatus, any>({
      path: `/admin/claims/${id}/receivable-contracts`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ListClaimTasks
   * @summary List claim tasks
   * @request GET:/admin/claims/{id}/tasks
   * @secure
   */
  listClaimTasks = (id: string, params: RequestParams = {}) =>
    this.request<ListTask, any>({
      path: `/admin/claims/${id}/tasks`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Will create a Slack Reminder for selected admin
   *
   * @tags Admin
   * @name UpsertTask
   * @summary Create or update a claim task
   * @request PUT:/admin/claims/{id}/tasks
   * @secure
   */
  upsertTask = (
    id: string,
    body: {
      assignedAdminId: string;
      /** If set, will upsert specified task */
      slackReminderId?: string;
      /** @example "Signifier la décision" */
      title: string;
      taskText?: string;
      /** @example "In two weeks" */
      dueDateString?: string;
      /** @format date-time */
      dueDate?: Date;
      /** @format date-time */
      completedAt?: Date;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/tasks`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveReservationItinerary
   * @summary Retrieve the complete itinerary details for specified reservation
   * @request GET:/admin/reservations/{id}/itinerary
   * @secure
   */
  retrieveReservationItinerary = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        id: string;
        /** @min 1 */
        gdsId: number;
        /** @min 1 */
        officeId: number;
        /** @example "MBZ24G" */
        gdsPnrId: string;
        segments: {
          /** @min 1 */
          id: number;
          uuid: string;
          flightId: string;
          reservationId: string;
          /** @min 1 */
          segmentNumber?: number;
          /** @example "AIRLINE" */
          cancelledBy?: "AIRLINE" | "CUSTOMER";
          /** @example "RECORD" */
          cancellationType?: "SEGMENT" | "RECORD";
          /** @format date-time */
          cancellationDate?: Date;
          cancellationSignature?: string;
          /** @min 1 */
          actualReroutingId: number;
          initialRecordNumber: number;
          /** Segment can have many Tickets (passengers). However, we take 1 from the reservation, as a reference for operation & computations (segment grouping etc). */
          referenceTicketNumber: string;
          /** @format date-time */
          syncDate: Date;
          /** @format date-time */
          legalScheduledDepartureUTC?: Date;
          /** @format date-time */
          legalScheduledArrivalUTC?: Date;
          /** @format date-time */
          confirmationDate: Date;
          /** @example "NOSHOW" */
          remarks?: string;
          waitlistIndicator: boolean;
          /** @min 1 */
          legNumber: number;
          /** @min 1 */
          seatNumber: number;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          flight: {
            id: string;
            airlineId: string;
            departureAirportId: string;
            arrivalAirportId: string;
            effectiveFlightId: string;
            diversionAirportId: string;
            /** @example "3196fe6900db41898cfa693f6ebe545f" */
            flightTrackingGuid?: string;
            distanceInkm: number;
            /**
             * @minLength 3
             * @maxLength 8
             * @example "AF80"
             */
            flightIdentifier: string;
            /** @format date-time */
            scheduledDepartureUTC: Date;
            /** @format date */
            scheduledDepartureLocal: Date;
            /** @format date-time */
            scheduledArrivalUTC: Date;
            /** @format date */
            scheduledArrivalLocal: Date;
            /** @format date-time */
            inGateArrivalUTC?: Date;
            /** @format date */
            inGateArrivalLocal?: Date;
            /** @format date-time */
            actualDepartureUTC?: Date;
            /** @format date */
            actualDepartureLocal?: Date;
            /** @example "2E" */
            departureTerminal?: string;
            /** @example "A" */
            arrivalTerminal?: string;
            /** @format date-time */
            checkinDateUTC?: Date;
            monitoringStatus?: string;
            isCodeshare: boolean;
            operatingAirlineId: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            airline: {
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "AF"
               */
              iata: string;
              /**
               * @maxLength 3
               * @example "AFR"
               */
              icao?: string;
              /** Is the airline under the 261/2004 regulation */
              isEC261: boolean;
              legalData?: {
                id: string;
                airlineId: string;
                companyId: string;
                legalContactEmail: string;
                personalLegalContactEmail: string;
                legalContactPhone?: string;
                /**
                 * 2 letters ISO country code
                 * @minLength 2
                 * @maxLength 2
                 * @example "FR"
                 */
                nationalityCountryCode: string;
                RCS: string;
                iconURL: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
              };
            };
            departureAirport: {
              /** Is the airport under the 261/2004 regulation */
              isEC261: boolean;
              /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "CDG"
               */
              iata: string;
              /** @example "Europe/Paris" */
              timezone: string;
              /** @example "Paris" */
              city: string;
              frTranslation?: string;
            };
            arrivalAirport: {
              /** Is the airport under the 261/2004 regulation */
              isEC261: boolean;
              /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "CDG"
               */
              iata: string;
              /** @example "Europe/Paris" */
              timezone: string;
              /** @example "Paris" */
              city: string;
              frTranslation?: string;
            };
          };
          reroutingProposal?: string;
          /** @minItems 0 */
          reroutingProposals: {
            id: number;
            impactedSegmentId: number;
            proposedSegmentId: number;
            stopoverNumber?: number;
            reroutingGroupId: number;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified?: Date;
            reroutingGroup: {
              id: number;
              reroutings: {
                id: number;
                impactedSegmentId: number;
                proposedSegmentId: number;
                stopoverNumber?: number;
                reroutingGroupId: number;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified?: Date;
                proposedSegment: {
                  /** @min 1 */
                  id: number;
                  uuid: string;
                  flightId: string;
                  reservationId: string;
                  /** @min 1 */
                  segmentNumber?: number;
                  /** @example "AIRLINE" */
                  cancelledBy?: "AIRLINE" | "CUSTOMER";
                  /** @example "RECORD" */
                  cancellationType?: "SEGMENT" | "RECORD";
                  /** @format date-time */
                  cancellationDate?: Date;
                  cancellationSignature?: string;
                  /** @min 1 */
                  actualReroutingId: number;
                  initialRecordNumber: number;
                  /** Segment can have many Tickets (passengers). However, we take 1 from the reservation, as a reference for operation & computations (segment grouping etc). */
                  referenceTicketNumber: string;
                  /** @format date-time */
                  syncDate: Date;
                  /** @format date-time */
                  legalScheduledDepartureUTC?: Date;
                  /** @format date-time */
                  legalScheduledArrivalUTC?: Date;
                  /** @format date-time */
                  confirmationDate: Date;
                  /** @example "NOSHOW" */
                  remarks?: string;
                  waitlistIndicator: boolean;
                  /** @min 1 */
                  legNumber: number;
                  /** @min 1 */
                  seatNumber: number;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified: Date;
                  flight: {
                    id: string;
                    airlineId: string;
                    departureAirportId: string;
                    arrivalAirportId: string;
                    effectiveFlightId: string;
                    diversionAirportId: string;
                    /** @example "3196fe6900db41898cfa693f6ebe545f" */
                    flightTrackingGuid?: string;
                    distanceInkm: number;
                    /**
                     * @minLength 3
                     * @maxLength 8
                     * @example "AF80"
                     */
                    flightIdentifier: string;
                    /** @format date-time */
                    scheduledDepartureUTC: Date;
                    /** @format date */
                    scheduledDepartureLocal: Date;
                    /** @format date-time */
                    scheduledArrivalUTC: Date;
                    /** @format date */
                    scheduledArrivalLocal: Date;
                    /** @format date-time */
                    inGateArrivalUTC?: Date;
                    /** @format date */
                    inGateArrivalLocal?: Date;
                    /** @format date-time */
                    actualDepartureUTC?: Date;
                    /** @format date */
                    actualDepartureLocal?: Date;
                    /** @example "2E" */
                    departureTerminal?: string;
                    /** @example "A" */
                    arrivalTerminal?: string;
                    /** @format date-time */
                    checkinDateUTC?: Date;
                    monitoringStatus?: string;
                    isCodeshare: boolean;
                    operatingAirlineId: string;
                    /** @format date-time */
                    createdAt: Date;
                    /** @format date-time */
                    lastModified: Date;
                    airline: {
                      name: string;
                      /**
                       * @minLength 2
                       * @maxLength 3
                       * @example "AF"
                       */
                      iata: string;
                      /**
                       * @maxLength 3
                       * @example "AFR"
                       */
                      icao?: string;
                      /** Is the airline under the 261/2004 regulation */
                      isEC261: boolean;
                      legalData?: {
                        iconURL?: string;
                      };
                    };
                    departureAirport: {
                      /** Is the airport under the 261/2004 regulation */
                      isEC261: boolean;
                      /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
                      name: string;
                      /**
                       * @minLength 2
                       * @maxLength 3
                       * @example "CDG"
                       */
                      iata: string;
                      /** @example "Europe/Paris" */
                      timezone: string;
                      city: string;
                    };
                    arrivalAirport: {
                      /** Is the airport under the 261/2004 regulation */
                      isEC261: boolean;
                      /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
                      name: string;
                      /**
                       * @minLength 2
                       * @maxLength 3
                       * @example "CDG"
                       */
                      iata: string;
                      /** @example "Europe/Paris" */
                      timezone: string;
                      city: string;
                    };
                  };
                };
              }[];
            };
          }[];
          actualRerouting?: string;
        }[];
      },
      any
    >({
      path: `/admin/reservations/${id}/itinerary`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RevolutHandleLoginRedirect
   * @summary OAuth login redirect from Revolut Buisiness API
   * @request GET:/admin/revolut/auth/sign-in
   * @secure
   */
  revolutHandleLoginRedirect = (params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/revolut/auth/sign-in`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description The link in generarly sent to passengers or enterprises via account manager
   *
   * @tags Admin, validation
   * @name GetFileUploadUrl
   * @summary Get unique public link to upload file to a Claim
   * @request GET:/admin/claims/{id}/documents/upload-url
   * @secure
   */
  getFileUploadUrl = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        /** @example "/f/c4175abf79b24dc9a43823ced1fc1134" */
        url: string;
        /** @example "https://upclaim.app.box.com/f/c4175abf79b24dc9a43823ced1fc1134" */
        href: string;
      },
      any
    >({
      path: `/admin/claims/${id}/documents/upload-url`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrievePnrContacts
   * @summary Retrieve a claim's contacts from PNR
   * @request GET:/admin/claims/{id}/history/contacts
   * @secure
   */
  retrievePnrContacts = (id: string, params: RequestParams = {}) =>
    this.request<ClaimContacts, any>({
      path: `/admin/claims/${id}/history/contacts`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RetrieveClaimETicketsHistory
   * @summary Retrieve a claim's reservation ETickets history
   * @request GET:/admin/claims/{id}/etickets/history
   * @secure
   */
  retrieveClaimETicketsHistory = (id: string, params: RequestParams = {}) =>
    this.request<UsersTicketsHistorySchema, any>({
      path: `/admin/claims/${id}/etickets/history`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description This route is used to get an easily shareable link, containing generated documents
   *
   * @tags Admin, validation
   * @name GetReceivablesBoxFolder
   * @summary Get public Box link for receivables contracts
   * @request GET:/admin/claims/{id}/documents/public-url
   * @secure
   */
  getReceivablesBoxFolder = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        publicLink: string;
        uploadToken: string;
        boxFolderId: string;
      },
      any
    >({
      path: `/admin/claims/${id}/documents/public-url`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Deprecated - Download an attachment from Front
   *
   * @tags Admin
   * @name RetrieveClaimAttachment
   * @summary Download a conversation attachment from Front
   * @request GET:/admin/plugins/front-app/attachments/{id}
   * @secure
   */
  retrieveClaimAttachment = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/plugins/front-app/attachments/${id}`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Deprecated - Remove a front attachment from a claim and from S3
   *
   * @tags Admin
   * @name RemoveClaimAttachment
   * @summary Remove a front attachment from a claim
   * @request DELETE:/admin/plugins/front-app/attachments/{id}
   * @secure
   */
  removeClaimAttachment = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/plugins/front-app/attachments/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SyncReservationTickets
   * @summary Sync reservation and its tickets
   * @request GET:/admin/reservations/{id}/tickets/sync
   * @secure
   */
  syncReservationTickets = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/reservations/${id}/tickets/sync`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description Retrieve all claim data associated with a front conversation.
   *
   * @tags Admin
   * @name RetrieveClaimFromConversationId
   * @summary Get claim data from a front conversation ID
   * @request GET:/admin/plugins/front-app/conversations/{id}/claim
   * @secure
   */
  retrieveClaimFromConversationId = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        id: string;
        claimTypeId: number;
        machineId: number;
        legalSpecificationId: string;
        acceptedExtraordinaryCircumstanceId?: string;
        /** Upclaim admin in charge of the case */
        assignedAdminId: string;
        /** Attorney in charge of the case */
        lawyerId: string;
        /**
         * @min 0
         * @max 20
         */
        claimLegalStepId: number;
        conversationId: string;
        parentClaimId: string;
        /** @min 1 */
        claimNumber: number;
        /** EditorJS data */
        adminNotes: string;
        customerNotes: string;
        passengersQuestion: string;
        /** @format date-time */
        nextLegalStepDueDate?: Date;
        needEligibilityVerification: boolean;
        /** @min 0 */
        claimStateId: number;
        /** @example "215592269992" */
        boxFolderId?: string;
        /** @example "228304838055" */
        boxFolderIdGeneratedRecevables?: string;
        /** @example "228304838055" */
        boxFolderIdThirdUpload?: string;
        /** @example "228304838055" */
        boxFolderIdIdentityProofs?: string;
        /** @example "228304838055" */
        boxFolderIdInvoices?: string;
        /** @format date-time */
        stateUpdatedAt: Date;
        /** @min 0 */
        tenantAssociationId?: number;
        inboxId: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        lastModified: Date;
        procedure: {
          id?: string;
          infogreffePayload: string;
          claimId: string;
          procedureType: "PROCEDURE_CLASSIQUE" | "ESCP";
          /** @example "2023F00210" */
          identifier: string;
          nextHearingId: number;
          /** @format date */
          decisionDate: Date;
          /** @format date */
          submissionDate: Date;
          statusDispayText: string;
          decisionDisplayText: string;
          /** @format date */
          createdAt: Date;
          /** @format date */
          lastModified: Date;
          juridictionId: number;
          nextHearing: {
            id: number;
            procedureId: string;
            /** @format date */
            hearingDate: Date;
            /** @format date-time */
            hearingDateIso: Date;
            lawyerId: number;
            globalUUID: string;
            /** @format date */
            lastModified: Date;
            /** @format date */
            createdAt: Date;
            hearingTypeId: number;
            afterHearingNotes: string;
            beforeHearingNotes: string;
            hearingType: {
              id: number;
              name:
                | "PLEA_HEARING"
                | "PROCEDURAL_HEARING_FOLLOWING_POSTPONEMENT_BY_US"
                | "PROCEDURAL_HEARING_FOLLOWING_POSTPONEMENT_BY_OPPOSING_PARTY"
                | "PROCEDURAL_HEARING";
            };
          };
          juridiction: {
            /** @min 1 */
            id: number;
            /** @example "Tribunal judiciaire Paris" */
            name: string;
            /** @min 1 */
            postalAddressId: number;
            /** @example 6401 */
            code: number;
            /** @example "www.greffe-tc-dax.fr" */
            website: string;
            /** @example "09h-12h/14h-17h" */
            schedule: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
          };
        };
        tenantAssociation: {
          /** @min 1 */
          id: number;
          claimId: string;
          sourceTenantId: string;
          sourceTenantType: "TRAVEL_AGENCY" | "ENTERPRISE";
          lawFirmTenantId: string;
          sourceTenant: {
            id: string;
            /** @example "Upclaim" */
            name: string;
            tenantType: "TRAVEL_AGENCY" | "ENTERPRISE" | "LAW_FIRM" | "UPCLAIM";
            /** @example "upclaim.eu" */
            domain: string;
            email: string;
            companyId: string;
            brandingId: string;
            /** @format date-time */
            createdAt: Date;
            tenantBranding?: {
              id: string;
              tenantId: string;
              logoUrl: string;
              iconUrl?: string;
              primaryColorHex?: string;
              secondaryColorHex?: string;
              backgroundColorHex?: string;
              twRadiusType?: string;
              signatureBoxUserId: string;
              /** @example "signature.upclaim.eu" */
              subdomainUri: string;
              activeCNAME: boolean;
              emailForPassengerContact?: string;
              whitelabelInboxId?: string;
              yousignWorkspaceId?: string;
              yousignExperienceId?: string;
              senderName?: string;
              replyTo?: string;
              postmarkappDomainId?: string;
              postmarkServerId?: string;
              additionalLogos: string[];
              postmarkappDomain?: {
                ID: string;
                Name: string;
                WeakDKIM: boolean;
                SPFVerified: boolean;
                DKIMVerified: boolean;
                ReturnPathDomainVerified: boolean;
                SPFHost?: string;
                SPFTextValue?: string;
                DKIMHost?: string;
                DKIMTextValue?: string;
                DKIMPendingHost?: string;
                DKIMPendingTextValue?: string;
                DKIMRevokedHost?: string;
                DKIMRevokedTextValue?: string;
                SafeToRemoveRevokedKeyFromDNS?: boolean;
                DKIMUpdateStatus?: "Pending" | "Verified" | "Failed";
                ReturnPathDomain?: string;
                ReturnPathDomainCNAMEValue?: string;
              };
              /** @format date-time */
              lastModified?: Date;
            };
          };
          lawFirmTenant?: {
            id: string;
            /** @example "Upclaim" */
            name: string;
            tenantType: "TRAVEL_AGENCY" | "ENTERPRISE" | "LAW_FIRM" | "UPCLAIM";
            /** @example "upclaim.eu" */
            domain: string;
            email: string;
            companyId: string;
            brandingId: string;
            /** @format date-time */
            createdAt: Date;
            tenantBranding?: {
              id: string;
              tenantId: string;
              logoUrl: string;
              iconUrl?: string;
              primaryColorHex?: string;
              secondaryColorHex?: string;
              backgroundColorHex?: string;
              twRadiusType?: string;
              signatureBoxUserId: string;
              /** @example "signature.upclaim.eu" */
              subdomainUri: string;
              activeCNAME: boolean;
              emailForPassengerContact?: string;
              whitelabelInboxId?: string;
              yousignWorkspaceId?: string;
              yousignExperienceId?: string;
              senderName?: string;
              replyTo?: string;
              postmarkappDomainId?: string;
              postmarkServerId?: string;
              additionalLogos: string[];
              postmarkappDomain?: {
                ID: string;
                Name: string;
                WeakDKIM: boolean;
                SPFVerified: boolean;
                DKIMVerified: boolean;
                ReturnPathDomainVerified: boolean;
                SPFHost?: string;
                SPFTextValue?: string;
                DKIMHost?: string;
                DKIMTextValue?: string;
                DKIMPendingHost?: string;
                DKIMPendingTextValue?: string;
                DKIMRevokedHost?: string;
                DKIMRevokedTextValue?: string;
                SafeToRemoveRevokedKeyFromDNS?: boolean;
                DKIMUpdateStatus?: "Pending" | "Verified" | "Failed";
                ReturnPathDomain?: string;
                ReturnPathDomainCNAMEValue?: string;
              };
              /** @format date-time */
              lastModified?: Date;
            };
          };
        };
        claimType: {
          id: number;
          name:
            | "FLIGHT_DELAY"
            | "FLIGHT_CANCELLATION"
            | "WRONG_ARRIVAL_AIRPORT"
            | "MISSED_CONNECTION_DUE_TO_DELAY"
            | "OVERBOOKING"
            | "COVID_ORDINANCE_2020"
            | "PNR_SEGMENT_CANCELLATION"
            | "DELAY_FROM_PNR_SCHEDULE"
            | "CONNECTION_DISRUPTION";
          isWholeFlightEligible: boolean;
          /**
           * Restricted scope of application (2 letters ISO country code)
           * @minLength 2
           * @maxLength 2
           * @example "FR"
           */
          passengerCitizenshipRequirement?: string;
        };
        claimLegalStep: {
          /**
           * @min 0
           * @max 20
           */
          id: number;
          name:
            | "CLAIM_VALIDATION"
            | "UPCLAIM"
            | "CONCILIATION"
            | "COURT"
            | "BAILIFF"
            | "CANCELLED"
            | "LOST"
            | "WAITING_FOR_MONEY"
            | "MONEY_RECEIVED"
            | "PAYMENT_SENT";
          isFinalStep: boolean;
          expectedDurationInDays: number;
          displayTextFr: string;
        };
        paymentAccount: {
          id: string;
          claimId: string;
          iban: string;
          /** @example "REVOLT21" */
          bic: string;
          /** @example "CHASDEFX" */
          intermediateBic?: string;
          /** @example "UPCLAIM" */
          beneficiary: string;
          /** @example 170 */
          beneficiaryAddressId: number;
          /** @example "FR" */
          countryCode: string;
          /** @example 0 */
          balance: number;
          /** @example "EUR" */
          currencyCode: string;
          thirdAccountId: string;
          /** @example true */
          isActive: boolean;
          /** @example 1 */
          bankId: number;
          ribFileId: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          balanceSyncedAt: Date;
          bank: {
            /** @min 1 */
            id: number;
            name: string;
            /** @min 1 */
            addressId: number;
          };
        };
        additionalRequests: {
          id: number;
          claimId: string;
          reason: string;
          additionalRequestTypeName:
            | "ARTICLE_700"
            | "PROCEDURE_COSTS"
            | "ABUSIVE_RESISTANCE"
            | "LACK_OF_INFORMATION_NOTICE";
          additionalRequestType: {
            id: number;
            type: "ARTICLE_700" | "PROCEDURE_COSTS" | "ABUSIVE_RESISTANCE" | "LACK_OF_INFORMATION_NOTICE";
            /** @example "Défaut de notice d'information" */
            displayText: string;
          };
          /**
           * In cents, 2 digits precision
           * @min 1
           * @max 9999999999999
           */
          amountRequested: number;
          /**
           * In cents, 2 digits precision
           * @min 0
           */
          amountReceived?: number;
          courtDecisionBoxFileId?: string;
          /** @format date-time */
          createdAt: Date;
        }[];
        claimExpenses: {
          id: number;
          claimId: string;
          expenseId: number;
          paidBy: string;
          userClaimId?: string;
          expense: {
            id: number;
            expenseTypeId: number;
            /** DecimalJS */
            price: string;
            /**
             * @minLength 3
             * @maxLength 3
             * @example "EUR"
             */
            currencyCode: string;
            isLostPrestation: boolean;
            expenseName?: string;
            claimDocumentId?: string;
            createdBy?: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            expenseType: {
              id: number;
              type:
                | "TRAIN"
                | "HOTEL"
                | "TAXI"
                | "OUTBOUND_FLIGHT"
                | "RETURN_FLIGHT"
                | "FOOD"
                | "PHONE_PLAN"
                | "TRAVEL_PACKAGE_SERVICE"
                | "OTHER"
                | "SALARY_COMPENSATION";
            };
            claimDocument?: {
              id: string;
              claimId: string;
              adminId: string;
              /** @min 0 */
              documentTypeId: number;
              fileId: string;
              description: string;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
              documentType: {
                /** @min 0 */
                id: number;
                type:
                  | "KBIS_UPCLAIM"
                  | "INVOICES_MERGED"
                  | "CLAIM_NOTIFICATION"
                  | "ELIGIBILITY_PROOF"
                  | "RIB_UPCLAIM"
                  | "FIRST_CONCILIATION_ATTEMPT"
                  | "MED"
                  | "MED_RECEIPT"
                  | "ESCP_A"
                  | "ESCP_B"
                  | "ESCP_C"
                  | "ESCP_D"
                  | "COURT_DECISION"
                  | "PLEADING_FILE"
                  | "OTHER"
                  | "LEGAL_SUBPOENA_SERVED"
                  | "DEBT_CONTRACT"
                  | "LEGAL_SUBPOENA_TO_REVIEW"
                  | "KBIS_OPPONENT"
                  | "ID_PROOF"
                  | "ETICKET"
                  | "DEBT_CONTRACT_ENTERPRISE"
                  | "DEBT_CONTRACT_TRAVEL_AGENCY_TO_UPCLAIM"
                  | "PROOF_OF_EXPENSE"
                  | "RECEIVABLE_TRAIL";
              };
              file: {
                id: string;
                name: string;
                size: number;
                /** @example "application/pdf" */
                mimeType: string;
                path: string;
                fileId: string;
                /** @example "1274366276920" */
                boxFileId: string;
                /** @example "1274366276920" */
                sha512: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
              };
              admin?: {
                id: string;
                tenantId: string;
                auth0Id: string;
                boxUserId: string;
                slackUserId: string;
                fullName: string;
                email: string;
                phone: string;
                isActive: boolean;
                invited: boolean;
                lawFirmId: string;
                legalContactPhone?: string;
                frontUserId?: string;
                /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
                profilePictureUrl: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
                roleId: number;
              };
            };
          };
        }[];
        claimEvents: {
          id: string;
          claimId: string;
          adminId: string;
          /** @min 0 */
          eventTypeId: number;
          /** @format date */
          eventDate: Date;
          internalNote: string;
          messageLink: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          eventType: {
            /** @min 0 */
            id: number;
            type:
              | "CLAIM_VALIDATION.CLOSE_CLAIM"
              | "CLAIM_VALIDATION.CLAIM_ELIGIBILITY_CONFIRMED"
              | "CLAIM_VALIDATION.DEBT_CONTRACT_SENT"
              | "CLAIM_VALIDATION.DEBT_SIGNED"
              | "UPCLAIM.FIRST_EMAIL_SENT"
              | "UPCLAIM.ABORTION"
              | "UPCLAIM.DISAGREE_AIRLINE_REPLY"
              | "UPCLAIM.AIRLINE_REPLY_DESERVES_FURTHER_STUDY"
              | "UPCLAIM.AIRLINE_AGREES_TO_PAY"
              | "UPCLAIM.AIRLINE_REPLY_DELAY_EXCEDEED"
              | "CONCILIATION.DISAGREE_AIRLINE_REPLY"
              | "CONCILIATION.AIRLINE_REPLY_DESERVES_FURTHER_STUDY"
              | "CONCILIATION.AIRLINE_AGREES_TO_PAY"
              | "CONCILIATION.AIRLINE_REPLY_DELAY_EXCEDEED"
              | "UPCLAIM.OUTBOUND_REPLY_SENT"
              | "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_RECEIVED"
              | "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_NOT_RECEIVED"
              | "COURT.JURIDCTION_CHOOSEN"
              | "CONCILIATION.OUTBOUND_REPLY_SENT"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_SENT_TO_AIRLINE"
              | "WAITING_FOR_MONEY.UPCLAIM_FOLLOW_UP"
              | "COURT.PROCEDURE_REPL"
              | "COURT.PROCEDURE_CLASSIQUE"
              | "COURT.PROCEDURE_BREF_DELAI"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_SIGNED_BY_AIRLINE"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_SIGNED_BY_AIRLINE"
              | "WAITING_FOR_MONEY.UPCLAIM_FOLLOW_UP_AIRLINE_AGREEMENT"
              | "WAITING_FOR_MONEY.UPCLAIM_NO_AGREEMENT_AFTER_FOLLOW_UP"
              | "COURT.ESCP_FORM_A_CHECK_NO_PLEAD"
              | "COURT.ESCP_FORM_A_CHECK_PLEAD"
              | "COURT.PROCEDURE_CLASSIQUE_DATE_SELECTED_TRIAL"
              | "COURT.BACK_TO_PROCEDURE_SELECTION"
              | "COURT.PROCEDURE_CLASSIQUE_BACK_JURIDICTION_SELECTED"
              | "COURT.PROCEDURE_CLASSIQUE_UNLOCKED_ABORTION"
              | "COURT.PROCEDURE_CLASSIQUE_UNLOCKED_AGREEMENT"
              | "COURT.BREF_DELAI_CHECK_CONCLUSIONS"
              | "COURT.BREF_DELAI_DATE_RECEIVED"
              | "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION_PAYMENT_RECEIVED"
              | "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION_PAYMENT_EXCEEDED_DELAY"
              | "WAITING_FOR_MONEY.CONCILIATION_FOLLOW_UP_SENT_WITHOUT_PROTOCOLE"
              | "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_RECEIVED_AFTER_FOLLOW_UP"
              | "WAITING_FOR_MONEY.UPCLAIM_PAYMENT_NOT_RECEIVED_AFTER_FOLLOW_UP"
              | "COURT.ESCP_FORM_A_SENT"
              | "COURT.ESCP_GROUP_CONFIRM_SAS_TRIAL_DATE"
              | "COURT.ESCP_BACK_CHOSSEN_TRIAL"
              | "COURT.PROCEDURE_CLASSIQUE_GROUP_CONFIRM_SAS_TRIAL_DATE"
              | "COURT.PROCEDURE_CLASSIQUE_BACK_TRIAL_DATE_SELECTED"
              | "COURT.BREF_DELAI_GRANTED"
              | "COURT.BREF_DELAI_REJECTED"
              | "WAITING_FOR_MONEY.COURT_DESISTEMENT_INSTANCE_ACTION"
              | "WAITING_FOR_MONEY.CONCILIATION_FOLLOW_UP_AFTER_TRANSACTIONAL_PROTOCOL"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_RECEIVED_AFTER_FOLLOW_UP"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_RECEIVED_AFTER_FOLLOW_UP"
              | "COURT.REPL_FORM_C_RECEIVED_COURT"
              | "COURT.ESPC_FORM_B_RECEIVED"
              | "COURT.PROCEDURE_CLASSIQUE_ASSIGNATION_CONFIRM_LAWYER"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL_REFERRAL"
              | "COURT.PROCEDURE_CLASSIQUE_SIMPLE_WITHDRAWAL"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_PAID_AFTER_FOLLOW_UP"
              | "WAITING_FOR_MONEY.CONCILIATION_TRANSACTIONAL_PROTOCOL_NOT_PAID_AFTER_FOLLOW_UP"
              | "COURT.REPL_WAITING_FOR_AIRLINE_REPLY_1"
              | "COURT.REPL_AIRLINE_REPLY_DELAY_EXCEDEED"
              | "COURT.ESCP_FORM_B_COURT_SENT"
              | "COURT.PROCEDURE_CLASSIQUE_SEND_ASSIGNATION_BAILIFF"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL_WON"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL_LOST"
              | "COURT.PROCEDURE_CLASSIQUE_AGREEMENT_LOCKED"
              | "COURT.PROCEDURE_CLASSIQUE_LOCKED_ABORTION"
              | "COURT.PROCEDURE_CLASSIQUE_LOCKED_BACK_COURT_CHOSEN"
              | "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_HOMOLOGATED_BY_COURT"
              | "COURT.ASSIGNATION_COPY_REVEIVED"
              | "COURT.AIRLINE_APPEAL"
              | "COURT.NO_AIRLINE_APPEAL"
              | "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_SENT_TO_AIRLINE"
              | "WAITING_FOR_MONEY.BAILIFF_SEIZED_AFTER_PROTOCOL_HOMOLOGATED_BY_COURT"
              | "COURT.REPL_ABORTION"
              | "COURT.REPL_AIRLINE_RIGHT_OF_REPLY_EXTENDED_EXERCISED"
              | "COURT.CLAIM_ENLISTMENT"
              | "COURT.AFTER_TRIAL_PAIEMENT_RECEIVED"
              | "COURT.AFTER_TRIAL_PAYMENT_EXCEED_DELAY"
              | "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_SIGNED_BY_AIRLINE"
              | "WAITING_FOR_MONEY.COURT_TRANSACTIONAL_PROTOCOL_NOT_SIGNED_BY_AIRLINE"
              | "COURT.PROCEDURE_CLASSIQUE_NO_AGREEMENT_WITH_AIRLINE"
              | "BAILIFF.AFTER_TRIAL"
              | "BAILIFF.AFTER_TRIAL_PAYMENT_RECEIVED"
              | "BAILIFF.FORCED_EXECUTION"
              | "BAILIFF.PAYMENT_RECEIVED"
              | "COURT.REPL_AIRLINE_REPLY_DELAY_EXCEDEED_WITH_PLEADING"
              | "COURT.REPL_AIRLINE_RIGHT_OF_REPLY_EXTENDED_EXERCISED_WITH_PLEADING"
              | "COURT.PROCEDURE_CLASSIQUE_TRIAL_NOTIFIED_DECISION"
              | "COURT.VICTORY_AFTER_AIRLINE_APPEAL"
              | "COURT.LOST_AFTER_AIRLINE_APPEAL"
              | "CLAIM_VALIDATION.AGENT_FEEDBACK_COLLECTED"
              | "CLAIM_VALIDATION.ADDITIONAL_LOSS_COLLECTED"
              | "CONCILIATION.ABORTION"
              | "COURT.PROCEDURE_CHOICE_ABORTION"
              | "CLAIM_VALIDATION.CLAIM_CREATED"
              | "UPCLAIM.MED_SENT"
              | "CLAIM_VALIDATION.DIRECT_PASSENGERS_CONTACT_CHOOSEN"
              | "CLAIM_VALIDATION.MANUAL_PASSENGERS_CONTACT_CHOOSEN"
              | "CLAIM_VALIDATION.ALL_PASSENGERS_HAVE_SIGNED"
              | "CLAIM_VALIDATION.ALL_PASSENGERS_HAVE_SIGNED_WITH_ENTERPRISE_LOSS"
              | "CLAIM_VALIDATION.ENTEPRISE_EXPENSES_COLLECTED"
              | "CLAIM_VALIDATION.ENTEPRISE_EXPENSES_COLLECTED_EMPTY"
              | "CLAIM_VALIDATION.ENTERPRISE_HAS_SIGNED"
              | "CLAIM_VALIDATION.ENTERPRISE_SIGNATURE_EXPIRED"
              | "CLAIM_VALIDATION.DEBT_CONTRACT_SENT_B2C_AND_B2B"
              | "CLAIM_VALIDATION.PASSENGERS_DEBT_SIGNED"
              | "CLAIM_VALIDATION.PASSENGERS_AND_ENTERPRISE_DEBT_SIGNED"
              | "PAYMENT_SENT"
              | "CLAIM_VALIDATION.DEBT_CONTRACT_SENT_MANUALLY";
            /** @example "1er email envoyé" */
            displayName: string;
            machineSourceId: string;
            /** @min 0 */
            machineId: number;
            sendNotification: boolean;
            /** @min 0 */
            claimLegalStepId: number;
            description?: string;
            /** @min 0 */
            claimStateId: number;
          };
          admin?: {
            id: string;
            tenantId: string;
            auth0Id: string;
            boxUserId: string;
            slackUserId: string;
            fullName: string;
            email: string;
            phone: string;
            isActive: boolean;
            invited: boolean;
            lawFirmId: string;
            legalContactPhone?: string;
            frontUserId?: string;
            /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
            profilePictureUrl: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            roleId: number;
          };
        }[];
        claimState: {
          /** @min 0 */
          id: number;
          type:
            | "CLAIM_VALIDATION.WAIT_FOR_ELIGIBILITY_CHECK"
            | "LOST"
            | "CLAIM_VALIDATION.WAIT_FOR_PASSENGERS_EMAILS_CHECK"
            | "CLAIM_VALIDATION.WAIT_FOR_PASSENGERS_EMAILS"
            | "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_CONTRACT_SEND"
            | "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_CONTRACT_SIGNATURES"
            | "UPCLAIM.WAIT_FOR_1ST_EMAIL_SEND"
            | "UPCLAIM.WAIT_FOR_AIRLINE_REPLY"
            | "CONCILIATION.WAIT_FOR_AIRLINE_REPLY"
            | "UPCLAIM.WAIT_FOR_UPCLAIM_REPLY"
            | "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT"
            | "COURT.WAIT_FOR_JURIDCTION_CHOICE"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT)FOR_TRANSACTIONAL_PROTOCOL_GENERATION"
            | "MONEY_RECEIVED"
            | "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_FOLLOW_UP_REDACTION"
            | "COURT.WAIT_FOR_PROCEDURE_CHOICE"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT)FOR_TRANSACTIONAL_PROTOCOL_SIGNATURE"
            | "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT_FOLLOW_UP_REPLY"
            | "COURT.WAIT_FOR_ESCP_FORM_A"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_TRIAL_DATE_CHOICE"
            | "COURT.BREF_DELAI_WAIT_FOR_PRESIDENT_APPOINTMENT_REPLY"
            | "WAITING_FOR_MONEY.WAIT_FOR_CARPA_PAYMENT"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_FOLLOW_UP_WITHOUT_PROTOCOLE"
            | "WAITING_FOR_MONEY.UPCLAIM_WAIT_FOR_PAYMENT_AFTER_FOLLOW_UP"
            | "COURT.WAIT_FOR_ESCP_FORM_A_SEND"
            | "COURT.WAIT_FOR_ESCP_GROUP"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_GROUP"
            | "COURT.BREF_DELAI_WAIT_FOR_PRESIDENT_APPOINTMENT_DATE"
            | "WAITING_FOR_MONEY.WAIT_FOR_COURT_DESISTEMENT_INSTANCE_ACTION"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_TRANSACTIONAL_PROTOCOLE_REDACTION"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_FOLLOW_UP_REPLY_WITHOUT_TRANSACTIONAL_PROTOCOLE_REPLY"
            | "COURT.WAIT_FOR_ESCP_FORM_A_COURT_RECEIPT"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_ASSIGNATION_GENERATION"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_HEARING"
            | "WAITING_FOR_MONEY.CONCILIATION_WAIT_FOR_TRANSACTIONAL_PROTOCOLE_REPLY"
            | "COURT.WAIT_FOR_ESCP_FORM_C_AIRLINE_REPLY"
            | "COURT.WAIT_FOR_ESCP_FORM_B"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_BAILLIF_TRANSMISSION"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_DELIBERATE_RESULTS"
            | "COURT.WAIT_FOR_CLAIM_DESTINY"
            | "WAITING_FOR_MONEY.COURT_WAIT_FOR_TRANSACTIONAL_PROTOCOL_SEND_TO_COURT"
            | "COURT.WAIT_FOR_ESCP_FORM_C_UPCLAIM_REPLY"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_BAILLIF_UPLOAD"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_TRIAL_SIGNIFICATION"
            | "WAITING_FOR_MONEY.COURT_WAIT_FOR_FORCED_EXECUTION"
            | "WAITING_FOR_MONEY.WAITING_FOR_TRANSACTIONAL_PROTOCOL"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_ENROLMENT"
            | "COURT.WAIT_FOR_APPEAL"
            | "WAITING_FOR_MONEY.WAITING_FOR_TRANSACTIONAL_PROTOCOL_SIGNATURE"
            | "COURT.PROCEDURE_CLASSIQUE_WAIT_FOR_CALENDAR_HEARING"
            | "COURT.WAIT_FOR_APPEAL_PROCEDURE"
            | "COURT.WAIT_FOR_PAYMENT_AFTER_TRIAL_VICTORY"
            | "BAILIFF.WAIT_FOR_BAILIF_CLAIM"
            | "BAILIFF.WAIT_FOR_BAILIF_REPLY"
            | "BAILIFF.WAIT_FOR_PAYMENT_AFTER_REQUISITION"
            | "CLAIM_VALIDATION.WAIT_FOR_AGENT_FEEDBACK"
            | "CLAIM_VALIDATION.WAIT_FOR_ADDITIONAL_LOSS_FEEDBACK"
            | "CLAIM_VALIDATION.WAIT_FOR_DOCUMENTS_CREATION"
            | "UPCLAIM.WAIT_SENDS_MED"
            | "CANCELLED"
            | "CLAIM_VALIDATION.CHOICE_OF_CONTACT_MODE"
            | "CLAIM_VALIDATION.WAIT_FOR_PASSENGER_YOUSIGN_SIGNATURE"
            | "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_TRAVEL_AGENCY"
            | "CLAIM_VALIDATION.WAIT_FOR_ENTERPRISE_ADDITIONAL_LOSS"
            | "CLAIM_VALIDATION.WAIT_FOR_ENTREPRISE_SIGNATURE"
            | "CLAIM_VALIDATION.WAIT_FOR_RECEIVABLE_CONTRACT_SIGNATURES_B2C_AND_B2B"
            | "PAYMENT_SENT";
          /** @example "Attente vérification éligibilité" */
          displayName: string;
          description?: string;
          machineSourceId: string;
          entryAction?: string;
          expectedDurationInDays: number;
          /** @min 0 */
          legalStepId: number;
        };
        agentFeedback: {
          id: string;
          sentToAdminId: string;
          claimId: string;
          validationOptionId: number;
          /** @format date-time */
          lastModified: Date;
          /** @format date-time */
          createdAt?: Date;
          note: string;
          b2c: boolean;
          additionalLoss?: string;
          admin: {
            id: string;
            tenantId: string;
            auth0Id: string;
            boxUserId: string;
            slackUserId: string;
            fullName: string;
            email: string;
            phone: string;
            isActive: boolean;
            invited: boolean;
            lawFirmId: string;
            legalContactPhone?: string;
            frontUserId?: string;
            /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
            profilePictureUrl: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            roleId: number;
          };
          validationOption: {
            id: number;
            claimTypeId: number;
            name: string;
            description: string;
            eligible: boolean;
          };
          /** @format date-time */
          additionalLossRequestSentAt?: Date;
        };
        claimDocuments: {
          id: string;
          claimId: string;
          adminId: string;
          /** @min 0 */
          documentTypeId: number;
          fileId: string;
          description: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          documentType: {
            /** @min 0 */
            id: number;
            type:
              | "KBIS_UPCLAIM"
              | "INVOICES_MERGED"
              | "CLAIM_NOTIFICATION"
              | "ELIGIBILITY_PROOF"
              | "RIB_UPCLAIM"
              | "FIRST_CONCILIATION_ATTEMPT"
              | "MED"
              | "MED_RECEIPT"
              | "ESCP_A"
              | "ESCP_B"
              | "ESCP_C"
              | "ESCP_D"
              | "COURT_DECISION"
              | "PLEADING_FILE"
              | "OTHER"
              | "LEGAL_SUBPOENA_SERVED"
              | "DEBT_CONTRACT"
              | "LEGAL_SUBPOENA_TO_REVIEW"
              | "KBIS_OPPONENT"
              | "ID_PROOF"
              | "ETICKET"
              | "DEBT_CONTRACT_ENTERPRISE"
              | "DEBT_CONTRACT_TRAVEL_AGENCY_TO_UPCLAIM"
              | "PROOF_OF_EXPENSE"
              | "RECEIVABLE_TRAIL";
          };
          file: {
            id: string;
            name: string;
            size: number;
            /** @example "application/pdf" */
            mimeType: string;
            path: string;
            fileId: string;
            /** @example "1274366276920" */
            boxFileId: string;
            /** @example "1274366276920" */
            sha512: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
          };
          admin?: {
            id: string;
            tenantId: string;
            auth0Id: string;
            boxUserId: string;
            slackUserId: string;
            fullName: string;
            email: string;
            phone: string;
            isActive: boolean;
            invited: boolean;
            lawFirmId: string;
            legalContactPhone?: string;
            frontUserId?: string;
            /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
            profilePictureUrl: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            roleId: number;
          };
        }[];
        conversation: {
          id: string;
          claimId?: string;
          inboxId?: string;
          /** @example "cnv_ibc6p1m" */
          frontConversationId: string;
          /** @format date-time */
          lastMessageReceivedOn: Date;
          /** @format date-time */
          lastMessageSentOn: Date;
          /** @format date-time */
          createdAt: Date;
        };
        machine: {
          /** @min 1 */
          id: number;
          /** @example "AIR_LITIGATION" */
          litigationName: "AIR_LITIGATION";
          /** @min 1 */
          versionNumber: number;
          versionDescription?: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified?: Date;
        };
        attachments: {
          id: string;
          name: string;
          size: number;
          type: string;
          sender: string;
          claimId: string;
          frontAttachmentId: string;
          /** @format date */
          createdAt: Date;
        }[];
        usersClaimsFamilies: {
          id: string;
          claimId: string;
          familyName: string;
          signerFullname?: string;
          /** For communicating with the family (signature request, events, etc) */
          email: string;
        }[];
        signatures: {
          id: string;
          /** @default "YOUSIGN" */
          service?: "YOUSIGN" | "BOX";
          thirdId: string;
          signatureFileId?: string;
          signatureTrailFileId?: string;
          /** @default "PENDING" */
          status?: "PENDING" | "COMPLETED" | "EXPIRED" | "DECLINED";
          /** @format date-time */
          statusUpdatedAt?: Date;
          claimId: string;
          /** @min 0 */
          totalAmountEuro: number;
          signatureType: "PASSENGER" | "ENTERPRISE" | "TRAVEL_AGENCY";
          signerEmail: string;
          ccEmails?: string;
          /** @format date-time */
          expirationDate?: Date;
          sequenceId?: string;
          declineReason?: string;
          /** @format date-time */
          createdAt?: Date;
        }[];
        usersClaims: {
          id: string;
          userId: string;
          userFlightId?: string;
          claimId: string;
          familyId: string;
          /** @min 1 */
          abortionId: number;
          /** @min 1 */
          legalDocumentsId: number;
          /** If White Label is set, we do not exist for the passengers:      No direct email, SMS or even Dashboard access for them */
          isWhiteLabel: boolean;
          /** Soft delete (Because of declined signature, etc */
          isRemoved: boolean;
          /**
           * Flight compensation amount as per Montreal Convention
           * @example 1250.89
           */
          montrealConventionCompensationAmount?: string;
          /** To prevent side-effects when creating manual claims */
          email: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          ticketImage: {
            /** @example "clmhjnjkd0006ye2yvkw2sl83" */
            id: string;
            /** @example "220-1026034047-49" */
            ticketNumber: string;
            lastImage?: string;
            beforeCancellationImage?: string;
            /** @example "Eric" */
            firstName: string;
            /** @example "Dupont" */
            lastName: string;
            userClaimId: string;
            /** @min 1 */
            segmentId: number;
            /** @format date-time */
            createdAt: Date;
          };
          user: {
            id: string;
            /** @example "Eric" */
            firstName: string;
            /** @example "Dupont" */
            lastName: string;
            /** @example "DUPONT/ERIC" */
            rawGdsName?: string;
            /** @example "eric.dupont@gmail.com" */
            email: string;
            /** @example "+33642424242" */
            phone: string;
            /**
             * 2 letters ISO country code
             * @minLength 2
             * @maxLength 2
             * @example "FR"
             */
            nationalityCountryCode: string;
            /** @format date */
            birthdate: Date;
            /**
             * ISO/IEC 5218: 1 for male, 2 for female
             * @min 0
             * @max 9
             */
            civility: number;
            /** @min 1 */
            postalAddressId?: number;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
          };
          expenses: {
            id: number;
            userClaimId: string;
            expenseId: number;
            expense: {
              id: number;
              expenseTypeId: number;
              /** DecimalJS */
              price: string;
              /**
               * @minLength 3
               * @maxLength 3
               * @example "EUR"
               */
              currencyCode: string;
              isLostPrestation: boolean;
              expenseName?: string;
              claimDocumentId?: string;
              createdBy?: string;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
              expenseType: {
                id: number;
                type:
                  | "TRAIN"
                  | "HOTEL"
                  | "TAXI"
                  | "OUTBOUND_FLIGHT"
                  | "RETURN_FLIGHT"
                  | "FOOD"
                  | "PHONE_PLAN"
                  | "TRAVEL_PACKAGE_SERVICE"
                  | "OTHER"
                  | "SALARY_COMPENSATION";
              };
              claimDocument?: {
                id: string;
                claimId: string;
                adminId: string;
                /** @min 0 */
                documentTypeId: number;
                fileId: string;
                description: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
                documentType: {
                  /** @min 0 */
                  id: number;
                  type:
                    | "KBIS_UPCLAIM"
                    | "INVOICES_MERGED"
                    | "CLAIM_NOTIFICATION"
                    | "ELIGIBILITY_PROOF"
                    | "RIB_UPCLAIM"
                    | "FIRST_CONCILIATION_ATTEMPT"
                    | "MED"
                    | "MED_RECEIPT"
                    | "ESCP_A"
                    | "ESCP_B"
                    | "ESCP_C"
                    | "ESCP_D"
                    | "COURT_DECISION"
                    | "PLEADING_FILE"
                    | "OTHER"
                    | "LEGAL_SUBPOENA_SERVED"
                    | "DEBT_CONTRACT"
                    | "LEGAL_SUBPOENA_TO_REVIEW"
                    | "KBIS_OPPONENT"
                    | "ID_PROOF"
                    | "ETICKET"
                    | "DEBT_CONTRACT_ENTERPRISE"
                    | "DEBT_CONTRACT_TRAVEL_AGENCY_TO_UPCLAIM"
                    | "PROOF_OF_EXPENSE"
                    | "RECEIVABLE_TRAIL";
                };
                file: {
                  id: string;
                  name: string;
                  size: number;
                  /** @example "application/pdf" */
                  mimeType: string;
                  path: string;
                  fileId: string;
                  /** @example "1274366276920" */
                  boxFileId: string;
                  /** @example "1274366276920" */
                  sha512: string;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified: Date;
                };
                admin?: {
                  id: string;
                  tenantId: string;
                  auth0Id: string;
                  boxUserId: string;
                  slackUserId: string;
                  fullName: string;
                  email: string;
                  phone: string;
                  isActive: boolean;
                  invited: boolean;
                  lawFirmId: string;
                  legalContactPhone?: string;
                  frontUserId?: string;
                  /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
                  profilePictureUrl: string;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified: Date;
                  roleId: number;
                };
              };
            };
          }[];
          userSegment: {
            /** @min 1 */
            id: number;
            userId: string;
            /** @min 1 */
            segmentId: number;
            userClaimId: string;
            rawTicketCiphered?: string;
            ticketNumber: string;
            /** @format date-time */
            ticketSyncedAt: Date;
            /** @format date-time */
            ticketIssueDate: Date;
            involuntaryIndicator: boolean;
            ticketLegStatus: string[];
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            ticket_leg_id?: string;
            segment?: {
              reservation: {
                /** @example "MBZ24G" */
                gdsPnrId: string;
                /** @format date-time */
                pnrCreatedAt: Date;
              };
              flight: {
                /**
                 * @minLength 3
                 * @maxLength 8
                 * @example "AF80"
                 */
                flightIdentifier: string;
                isCodeshare: boolean;
                airline: {
                  name: string;
                  /**
                   * @minLength 2
                   * @maxLength 3
                   * @example "AF"
                   */
                  iata: string;
                  /**
                   * @maxLength 3
                   * @example "AFR"
                   */
                  icao?: string;
                };
              };
            };
          };
        }[];
        legalSpecification: {
          id: string;
          claimId: string;
          airlineId: string;
          effectiveFlightId: string;
          /**
           * Flight compensation amount under EU 261/2004 regulation
           * @min 0
           * @max 600
           */
          ec261CompensationAmount: number;
          /** @min 1 */
          impactedSegmentId: number;
          /**
           * Wether the ticket should be refunded or not, in addition of having the compensation
           * @default false
           */
          shouldTicketBeRefunded: boolean;
          /**
           * @min 0
           * @max 100
           */
          b2cCommissionPercentageForUpclaim: number;
          /**
           * @min 0
           * @max 100
           */
          b2cCommissionPercentageForTravelAgency: number;
          /**
           * @min 0
           * @max 100
           */
          b2bCommissionPercentageForUpclaim: number;
          /**
           * @min 0
           * @max 100
           */
          b2bCommissionPercentageForTravelAgency: number;
          /**
           * @min 0
           * @max 100
           */
          travelAgencyLossCommissionPercentageForUpclaim: number;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
          impactedSegment: {
            /** @min 1 */
            id: number;
            uuid: string;
            flightId: string;
            reservationId: string;
            /** @min 1 */
            segmentNumber?: number;
            /** @example "AIRLINE" */
            cancelledBy?: "AIRLINE" | "CUSTOMER";
            /** @example "RECORD" */
            cancellationType?: "SEGMENT" | "RECORD";
            /** @format date-time */
            cancellationDate?: Date;
            cancellationSignature?: string;
            /** @min 1 */
            actualReroutingId: number;
            initialRecordNumber: number;
            /** Segment can have many Tickets (passengers). However, we take 1 from the reservation, as a reference for operation & computations (segment grouping etc). */
            referenceTicketNumber: string;
            /** @format date-time */
            syncDate: Date;
            /** @format date-time */
            legalScheduledDepartureUTC?: Date;
            /** @format date-time */
            legalScheduledArrivalUTC?: Date;
            /** @format date-time */
            confirmationDate: Date;
            /** @example "NOSHOW" */
            remarks?: string;
            waitlistIndicator: boolean;
            /** @min 1 */
            legNumber: number;
            /** @min 1 */
            seatNumber: number;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            /** @minItems 0 */
            reroutingProposals: {
              id: number;
              impactedSegmentId: number;
              proposedSegmentId: number;
              stopoverNumber?: number;
              reroutingGroupId: number;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified?: Date;
              reroutingGroup: {
                id: number;
                reroutings: {
                  id: number;
                  impactedSegmentId: number;
                  proposedSegmentId: number;
                  stopoverNumber?: number;
                  reroutingGroupId: number;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified?: Date;
                  proposedSegment: {
                    /** @min 1 */
                    id: number;
                    uuid: string;
                    flightId: string;
                    reservationId: string;
                    /** @min 1 */
                    segmentNumber?: number;
                    /** @example "AIRLINE" */
                    cancelledBy?: "AIRLINE" | "CUSTOMER";
                    /** @example "RECORD" */
                    cancellationType?: "SEGMENT" | "RECORD";
                    /** @format date-time */
                    cancellationDate?: Date;
                    cancellationSignature?: string;
                    /** @min 1 */
                    actualReroutingId: number;
                    initialRecordNumber: number;
                    /** Segment can have many Tickets (passengers). However, we take 1 from the reservation, as a reference for operation & computations (segment grouping etc). */
                    referenceTicketNumber: string;
                    /** @format date-time */
                    syncDate: Date;
                    /** @format date-time */
                    legalScheduledDepartureUTC?: Date;
                    /** @format date-time */
                    legalScheduledArrivalUTC?: Date;
                    /** @format date-time */
                    confirmationDate: Date;
                    /** @example "NOSHOW" */
                    remarks?: string;
                    waitlistIndicator: boolean;
                    /** @min 1 */
                    legNumber: number;
                    /** @min 1 */
                    seatNumber: number;
                    /** @format date-time */
                    createdAt: Date;
                    /** @format date-time */
                    lastModified: Date;
                    flight: {
                      id: string;
                      airlineId: string;
                      departureAirportId: string;
                      arrivalAirportId: string;
                      effectiveFlightId: string;
                      diversionAirportId: string;
                      /** @example "3196fe6900db41898cfa693f6ebe545f" */
                      flightTrackingGuid?: string;
                      distanceInkm: number;
                      /**
                       * @minLength 3
                       * @maxLength 8
                       * @example "AF80"
                       */
                      flightIdentifier: string;
                      /** @format date-time */
                      scheduledDepartureUTC: Date;
                      /** @format date */
                      scheduledDepartureLocal: Date;
                      /** @format date-time */
                      scheduledArrivalUTC: Date;
                      /** @format date */
                      scheduledArrivalLocal: Date;
                      /** @format date-time */
                      inGateArrivalUTC?: Date;
                      /** @format date */
                      inGateArrivalLocal?: Date;
                      /** @format date-time */
                      actualDepartureUTC?: Date;
                      /** @format date */
                      actualDepartureLocal?: Date;
                      /** @example "2E" */
                      departureTerminal?: string;
                      /** @example "A" */
                      arrivalTerminal?: string;
                      /** @format date-time */
                      checkinDateUTC?: Date;
                      monitoringStatus?: string;
                      isCodeshare: boolean;
                      operatingAirlineId: string;
                      /** @format date-time */
                      createdAt: Date;
                      /** @format date-time */
                      lastModified: Date;
                      airline: {
                        name: string;
                        /**
                         * @minLength 2
                         * @maxLength 3
                         * @example "AF"
                         */
                        iata: string;
                        /**
                         * @maxLength 3
                         * @example "AFR"
                         */
                        icao?: string;
                        /** Is the airline under the 261/2004 regulation */
                        isEC261: boolean;
                        legalData?: {
                          iconURL?: string;
                        };
                      };
                      departureAirport: {
                        /** Is the airport under the 261/2004 regulation */
                        isEC261: boolean;
                        /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
                        name: string;
                        /**
                         * @minLength 2
                         * @maxLength 3
                         * @example "CDG"
                         */
                        iata: string;
                        /** @example "Europe/Paris" */
                        timezone: string;
                        city: string;
                      };
                      arrivalAirport: {
                        /** Is the airport under the 261/2004 regulation */
                        isEC261: boolean;
                        /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
                        name: string;
                        /**
                         * @minLength 2
                         * @maxLength 3
                         * @example "CDG"
                         */
                        iata: string;
                        /** @example "Europe/Paris" */
                        timezone: string;
                        city: string;
                      };
                    };
                  };
                }[];
              };
            }[];
            actualRerouting?: string;
            reservation: {
              id: string;
              /** @min 1 */
              gdsId: number;
              /** @min 1 */
              officeId: number;
              /** @example "MBZ24G" */
              gdsPnrId: string;
              upclaimContactEmail: string;
              journeyHistory?: string;
              /** @format date-time */
              pnrCreatedAt: Date;
              /** @format date-time */
              syncDate?: Date;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
              travelAgencyOffice: {
                id: number;
                travelAgencyId: string;
                amadeusOfficeId: string;
                /** @format date */
                lastImportDate?: Date;
                name?: string;
                /** @format date */
                createdAt: Date;
                /** @format date */
                lastModified?: Date;
                fallbackAgentEmail?: string;
                fallbackAccountManagerEmail?: string;
                isBusinessTravel: boolean;
                isDirectPassengerContactAllowed?: boolean;
              };
              travelAgencyCompany: {
                id: string;
                travelAgencyId: string;
                companyId: string;
                /** @example "radiofrance.fr" */
                domain: string;
                /** @example "Radio France" */
                displayName: string;
                /** @example "RADIO FRANCE" */
                rawGdsName: string;
                iconUrl: string;
                mainContactEmail: string;
                defaultTravelAgentAdminId: string;
                accountManagerId: string;
                bluebizIdentifier?: string;
                isDirectPassengerContactAllowed: boolean;
                passengersSignaturesForwardEmail: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
              };
              travelAgencyAgent: {
                id: string;
                adminId: string;
                gdsSignature: string;
                travelAgencyId: string;
                isDirectPassengerContactAllowed: boolean;
                isBusinessTravelAgent: boolean;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
                admin: {
                  id: string;
                  tenantId: string;
                  auth0Id: string;
                  boxUserId: string;
                  slackUserId: string;
                  fullName: string;
                  email: string;
                  phone: string;
                  isActive: boolean;
                  invited: boolean;
                  lawFirmId: string;
                  legalContactPhone?: string;
                  frontUserId?: string;
                  /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
                  profilePictureUrl: string;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified: Date;
                  roleId: number;
                };
              };
            };
          };
          effectiveAirline: {
            name: string;
            /**
             * @minLength 2
             * @maxLength 3
             * @example "AF"
             */
            iata: string;
            /**
             * @maxLength 3
             * @example "AFR"
             */
            icao?: string;
            /** Is the airline under the 261/2004 regulation */
            isEC261: boolean;
            legalData: {
              id: string;
              airlineId: string;
              companyId: string;
              legalContactEmail: string;
              personalLegalContactEmail: string;
              legalContactPhone?: string;
              /**
               * 2 letters ISO country code
               * @minLength 2
               * @maxLength 2
               * @example "FR"
               */
              nationalityCountryCode: string;
              RCS: string;
              iconURL: string;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
            };
          };
          effectiveFlight: {
            id: string;
            airlineId: string;
            departureAirportId: string;
            arrivalAirportId: string;
            effectiveFlightId: string;
            diversionAirportId: string;
            /** @example "3196fe6900db41898cfa693f6ebe545f" */
            flightTrackingGuid?: string;
            distanceInkm: number;
            /**
             * @minLength 3
             * @maxLength 8
             * @example "AF80"
             */
            flightIdentifier: string;
            /** @format date-time */
            scheduledDepartureUTC: Date;
            /** @format date */
            scheduledDepartureLocal: Date;
            /** @format date-time */
            scheduledArrivalUTC: Date;
            /** @format date */
            scheduledArrivalLocal: Date;
            /** @format date-time */
            inGateArrivalUTC?: Date;
            /** @format date */
            inGateArrivalLocal?: Date;
            /** @format date-time */
            actualDepartureUTC?: Date;
            /** @format date */
            actualDepartureLocal?: Date;
            /** @example "2E" */
            departureTerminal?: string;
            /** @example "A" */
            arrivalTerminal?: string;
            /** @format date-time */
            checkinDateUTC?: Date;
            monitoringStatus?: string;
            isCodeshare: boolean;
            operatingAirlineId: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
            airline: {
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "AF"
               */
              iata: string;
              /**
               * @maxLength 3
               * @example "AFR"
               */
              icao?: string;
              /** Is the airline under the 261/2004 regulation */
              isEC261: boolean;
              legalData?: {
                id: string;
                airlineId: string;
                companyId: string;
                legalContactEmail: string;
                personalLegalContactEmail: string;
                legalContactPhone?: string;
                /**
                 * 2 letters ISO country code
                 * @minLength 2
                 * @maxLength 2
                 * @example "FR"
                 */
                nationalityCountryCode: string;
                RCS: string;
                iconURL: string;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
              };
            };
            departureAirport: {
              /** Is the airport under the 261/2004 regulation */
              isEC261: boolean;
              /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "CDG"
               */
              iata: string;
              /** @example "Europe/Paris" */
              timezone: string;
              /** @example "Paris" */
              city: string;
              frTranslation?: string;
            };
            arrivalAirport: {
              /** Is the airport under the 261/2004 regulation */
              isEC261: boolean;
              /** @example "Charles de Gaulle Airport, Roissy, Paris (CDG)" */
              name: string;
              /**
               * @minLength 2
               * @maxLength 3
               * @example "CDG"
               */
              iata: string;
              /** @example "Europe/Paris" */
              timezone: string;
              /** @example "Paris" */
              city: string;
              frTranslation?: string;
            };
          };
        };
      },
      any
    >({
      path: `/admin/plugins/front-app/conversations/${id}/claim`,
      method: "GET",
      secure: true,
      ...params,
    });
  /**
   * @description This is a manual admin action only, for now
   *
   * @tags Admin
   * @name CreateExternalClaim
   * @summary Create an external claim
   * @request POST:/admin/claims
   * @secure
   */
  createExternalClaim = (
    body: {
      note?: string;
      reservation: {
        /** @example "T1BGEV" */
        pnrId: string;
        /** Default to passive office ID */
        officeId: string;
      };
      claim: {
        claimType:
          | "FLIGHT_DELAY"
          | "FLIGHT_CANCELLATION"
          | "WRONG_ARRIVAL_AIRPORT"
          | "MISSED_CONNECTION_DUE_TO_DELAY"
          | "OVERBOOKING"
          | "COVID_ORDINANCE_2020"
          | "PNR_SEGMENT_CANCELLATION"
          | "DELAY_FROM_PNR_SCHEDULE"
          | "CONNECTION_DISRUPTION";
        /**
         * Flight compensation amount under EU 261/2004 regulation
         * @min 0
         * @max 600
         */
        ec261CompensationAmount: number;
        delayInMinutes?: number;
        /**
         * Wether the ticket should be refunded or not, in addition of having the compensation
         * @default false
         */
        shouldTicketBeRefunded?: boolean;
        cancellationNotice?: "LESS_THAN_7_DAYS" | "BETWEEN_7_AND_14_DAYS" | "MORE_THAN_14_DAYS" | "NOT_NOTIFIED";
      };
      flight: {
        /**
         * @minLength 3
         * @maxLength 8
         * @example "AF80"
         */
        flightIdentifier: string;
        /**
         * @minLength 2
         * @maxLength 3
         * @example "CDG"
         */
        departureAirportIATA: string;
        /**
         * @minLength 2
         * @maxLength 3
         * @example "CDG"
         */
        arrivalAirportIATA: string;
        schedule: {
          /** @example "25/07/2023 19:00" */
          scheduledDepartureLocal?: string;
          /** @example "25/07/2023 23:00" */
          actualDepartureLocal?: string;
          /** @example "26/07/2023 07:00" */
          scheduledArrivalLocal?: string;
          /** @example "26/07/2023 10:30" */
          inGateArrivalLocal?: string;
        };
      };
      /** @minItems 1 */
      passengers: {
        /** @example "Eric" */
        firstName: string;
        /** @example "Dupont" */
        lastName: string;
        email?: string;
        ticketNumber?: string;
        /** @example "+33642424242" */
        phone?: string;
        /**
         * 2 letters ISO country code
         * @minLength 2
         * @maxLength 2
         * @example "FR"
         */
        nationalityCountryCode: string;
        /**
         * ISO/IEC 5218: 1 for male, 2 for female
         * @min 0
         * @max 9
         * @default 0
         */
        civility?: number;
        /** @example "34 rue de l'Echiquier" */
        streetAddress?: string;
        /** @example "Paris" */
        city?: string;
        /** @example "75010" */
        zipCode?: string;
        /**
         * 2 letters ISO country code
         * @minLength 2
         * @maxLength 2
         * @example "FR"
         */
        addressCountryCode?: string;
        /** @format date */
        birthdate?: Date;
        /**
         * Flight compensation amount as per Montreal Convention
         * @example 1250.89
         */
        montrealConventionCompensationAmount?: string;
        documents?: {
          reservationConfirmationFileURL?: string;
          cancellationConfirmationFileURL?: string;
          youSignClaimFileURL?: string;
          invoicesFilesURL?: string[];
        };
      }[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
        claim?: {
          id: string;
          claimTypeId: number;
          machineId: number;
          legalSpecificationId: string;
          acceptedExtraordinaryCircumstanceId?: string;
          /** Upclaim admin in charge of the case */
          assignedAdminId: string;
          /** Attorney in charge of the case */
          lawyerId: string;
          /**
           * @min 0
           * @max 20
           */
          claimLegalStepId: number;
          conversationId: string;
          parentClaimId: string;
          /** @min 1 */
          claimNumber: number;
          /** EditorJS data */
          adminNotes: string;
          customerNotes: string;
          passengersQuestion: string;
          /** @format date-time */
          nextLegalStepDueDate?: Date;
          needEligibilityVerification: boolean;
          /** @min 0 */
          claimStateId: number;
          /** @example "215592269992" */
          boxFolderId?: string;
          /** @example "228304838055" */
          boxFolderIdGeneratedRecevables?: string;
          /** @example "228304838055" */
          boxFolderIdThirdUpload?: string;
          /** @example "228304838055" */
          boxFolderIdIdentityProofs?: string;
          /** @example "228304838055" */
          boxFolderIdInvoices?: string;
          /** @format date-time */
          stateUpdatedAt: Date;
          /** @min 0 */
          tenantAssociationId?: number;
          inboxId: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
        boxToken?: string;
      },
      any
    >({
      path: `/admin/claims`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name UpsertCompany
   * @summary Upsert a company detail
   * @request POST:/admin/companies
   * @secure
   */
  upsertCompany = (
    body: {
      /** @example "Upclaim" */
      name?: string;
      /**
       * @pattern ^[0-9]{9}$
       * @example "890120587"
       */
      siren?: string;
      /**
       * @pattern ^[0-9]{14}$
       * @example "89012058700021"
       */
      siret?: string;
      /**
       * @pattern ^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$
       * @example "ATU72316013"
       */
      euVAT?: string;
      /** @example "upclaim.eu" */
      domain?: string;
      logoUrl?: string;
      pappersData?: string;
      /** Tribunal de commerce en fonction du siège de la société */
      competentCourtId?: number;
      /**
       * Pour override celles générées à partir des Pappers data
       * @example "UPCLAIM, société par actions simplifiée au capital social de 1500 €, dont le siège social est situé au 88 BD VOLTAIRE 75011 PARIS 11, immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 890 120 587, représentée par M. Victor Boinet agissant et ayant les pouvoirs nécessaires en tant que président."
       */
      legalNotices?: string;
      postalAddress?: {
        /** Address label description */
        label?: string;
        nameLine?: string;
        /** @example "34 rue de l'Echiquier" */
        streetAddress: string;
        streetAddressComplement?: string;
        /** @example "Paris" */
        city: string;
        /** @example "75010" */
        zipCode?: string;
        /** @example "Île-de-France" */
        region?: string;
        /**
         * @minLength 2
         * @maxLength 2
         * @default "FR"
         * @example "FR"
         */
        countryCode?: string;
      };
      travelAgencyCompanyId?: string;
      airlineId?: string;
      travelAgencyId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        id: string;
        /** @example "Upclaim" */
        name: string;
        /**
         * @pattern ^[0-9]{9}$
         * @example "890120587"
         */
        siren: string;
        /**
         * @pattern ^[0-9]{14}$
         * @example "89012058700021"
         */
        siret: string;
        /**
         * @pattern ^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$
         * @example "ATU72316013"
         */
        euVAT: string;
        /** @example "upclaim.eu" */
        domain?: string;
        logoUrl?: string;
        pappersData?: string;
        boxFolderId?: string;
        kbisBoxFileId?: string;
        /** @format date-time */
        pappersDataSyncedAt: Date;
        postalAddressId?: number;
        /** Tribunal de commerce en fonction du siège de la société */
        competentCourtId?: number;
        /**
         * Pour override celles générées à partir des Pappers data
         * @example "UPCLAIM, société par actions simplifiée au capital social de 1500 €, dont le siège social est situé au 88 BD VOLTAIRE 75011 PARIS 11, immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 890 120 587, représentée par M. Victor Boinet agissant et ayant les pouvoirs nécessaires en tant que président."
         */
        legalNotices?: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        lastModified: Date;
        postalAddress?: {
          /** @min 1 */
          id: number;
          /** Address label description */
          label?: string;
          nameLine?: string;
          /** @example "34 rue de l'Echiquier" */
          streetAddress: string;
          streetAddressComplement?: string;
          /** @example "Paris" */
          city: string;
          /** @example "75010" */
          zipCode: string;
          /** @example "Île-de-France" */
          region: string;
          /**
           * @minLength 2
           * @maxLength 2
           * @example "FR"
           */
          countryCode: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          updatedAt?: Date;
        };
        juridiction?: {
          /** @min 1 */
          id: number;
          /** @example "Tribunal judiciaire Paris" */
          name: string;
          /** @min 1 */
          postalAddressId: number;
          /** @example 6401 */
          code: number;
          /** @example "www.greffe-tc-dax.fr" */
          website: string;
          /** @example "09h-12h/14h-17h" */
          schedule: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
      },
      any
    >({
      path: `/admin/companies`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name InviteAdmin
   * @summary Invite an admin to join Upclaim
   * @request POST:/admin/admins/invite
   * @secure
   */
  inviteAdmin = (
    body: {
      adminsIds?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/admins/invite`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Triggered when some employee have added invoices (Or said enterprise might had some expenses)
   *
   * @tags Admin
   * @name LaunchAccountManagerWorkflow
   * @summary Begin account manager feedback flow (Email sequence)
   * @request POST:/admin/automated-workflows/account-manager-feedback
   * @secure
   */
  launchAccountManagerWorkflow = (
    body: {
      claimId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/admin/automated-workflows/account-manager-feedback`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description When we are unsure about a claim, a need their input
   *
   * @tags Admin
   * @name LaunchAgentFeedbackWorkflow
   * @summary Ask for agent feedback flow (Email sequence)
   * @request POST:/admin/automated-workflows/agent-feedback
   * @secure
   */
  launchAgentFeedbackWorkflow = (
    body: {
      claimId: string;
      agentEmail: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/admin/automated-workflows/agent-feedback`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Specified Box File should have `familyId` metadata set
   *
   * @tags Admin
   * @name LaunchFamilyAcquisitionWorkflow
   * @summary Begin a family acquisition flow (Email sequence)
   * @request POST:/admin/automated-workflows/family-claim-acquisition
   * @secure
   */
  launchFamilyAcquisitionWorkflow = (
    body: {
      claimId: string;
      familyId: string;
      signerEmail: string;
      /** @minLength 2 */
      signerFullName?: string;
      boxFileId: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/admin/automated-workflows/family-claim-acquisition`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SearchFlight
   * @summary Retrieve an historical flight data from OAG and other API sources
   * @request POST:/admin/flights/search
   * @secure
   */
  searchFlight = (
    body: {
      /**
       * @minLength 3
       * @maxLength 8
       * @example "AF80"
       */
      flightIdentifier: string;
      /** @format date-time */
      scheduledDepartureUTC: Date;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/admin/flights/search`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description This route only needs to be called for European Small Claim Procedure (ESCP) for now
   *
   * @tags Admin
   * @name InitClaimProcedure
   * @summary Initialize a claim procedure
   * @request POST:/admin/claims/{id}/procedure
   * @secure
   */
  initClaimProcedure = (
    id: string,
    body: {
      juridictionId: number;
      procedureType: "PROCEDURE_CLASSIQUE" | "ESCP";
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/procedure`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name AddEvent
   * @summary Add an event to a claim
   * @request POST:/admin/claims/{id}/events
   * @secure
   */
  addEvent = (
    id: string,
    body: {
      internalNote?: string;
      /** @example "https://app.frontapp.com/open/msg_ac7lc5z" */
      messageLink?: string;
      /** @example "1er email envoyé" */
      machineEvent: string;
      /** @format date-time */
      eventDate?: Date;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/events`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Used to present claim validation status and sent emails history (opens, reminders, etc)
   *
   * @tags Admin, validation
   * @name ListClaimAcquisitions
   * @summary List claim acquisition per family : Status, sent emails, notes etc
   * @request POST:/admin/claims/{id}/acquisitions
   * @secure
   */
  listClaimAcquisitions = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        families: {
          id: string;
          claimId: string;
          familyId: string;
          enterpriseId: string;
          enterpriseReferentEmail: string;
          toEmail: string;
          fromEmail: string;
          signatureRequestId?: string;
          /** @default "CONFIRM" */
          step: "CONFIRM" | "EXPENSES" | "SIGNATURE" | "COMPLETE" | "DECLINED" | "EXPIRED";
          /** @default "CONFIRM,EXPENSES,SIGNATURE,COMPLETE" */
          stepsSequence: string;
          confirmationSequenceId: string;
          expensesSequenceId: string;
          additionalDocsSequenceId: string;
          /** @format date-time */
          expirationDate: Date;
          receivableBoxFileId: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          linkClickedAt: Date;
          declineReason: string;
          passengerNote: string;
          expensesNote: string;
          mayHaveEnterpriseExpenses: boolean;
          preExistingClaim: boolean;
          /** @format date-time */
          stepUpdatedAt: Date;
          signature: {
            id: string;
            /** @default "YOUSIGN" */
            service?: "YOUSIGN" | "BOX";
            thirdId: string;
            signatureFileId?: string;
            signatureTrailFileId?: string;
            /** @default "PENDING" */
            status?: "PENDING" | "COMPLETED" | "EXPIRED" | "DECLINED";
            /** @format date-time */
            statusUpdatedAt?: Date;
            claimId: string;
            /** @min 0 */
            totalAmountEuro: number;
            signatureType: "PASSENGER" | "ENTERPRISE" | "TRAVEL_AGENCY";
            signerEmail: string;
            ccEmails?: string;
            /** @format date-time */
            expirationDate?: Date;
            sequenceId?: string;
            declineReason?: string;
            /** @format date-time */
            createdAt?: Date;
          };
          confirmationSequence: {
            id: string;
            /** @example "family-claim-acquisition-confirmation" */
            workflowTypeKey: string;
            claimId: string;
            thirdRunId?: string;
            /** @min 0 */
            currentStepNumber: number;
            /** @format date-time */
            triggeredAt?: Date;
            /** @format date-time */
            completedAt?: Date;
            /** @format date-time */
            lastRun?: Date;
            /** @format date-time */
            cancelledAt?: Date;
            /** @format date-time */
            expirationDate?: Date;
            emails: {
              id: string;
              inboxId: string;
              emlFileId?: string;
              pdfFileId?: string;
              to: string[];
              fromEmail: string;
              fromName?: string;
              cc?: string[];
              bcc?: string[];
              subject: string;
              textBody: string;
              htmlBody: string;
              headers?: string[];
              messageId: string;
              replyTo?: string;
              inReplyTo?: string;
              references: string[];
              blockedReason?: string;
              status: string;
              postmarkOpensDetails?: {
                Opens?: {
                  OS?: {
                    Name?: string;
                    Family?: string;
                    Company?: string;
                  };
                  Geo?: {
                    IP?: string;
                    Zip?: string;
                    City?: string;
                    Coords?: string;
                    Region?: string;
                    Country?: string;
                    RegionISOCode?: string;
                    CountryISOCode?: string;
                  };
                  Tag?: string;
                  Client?: {
                    Name?: string;
                    Family?: string;
                    Company?: string;
                  };
                  Platform?: string;
                  MessageID: string;
                  Recipient: string;
                  UserAgent?: string;
                  /** @format date-time */
                  ReceivedAt: Date;
                  RecordType: "Open" | "Click" | "Bounce" | "Spam";
                  /** @min 0 */
                  ReadSeconds?: number;
                  MessageStream?: string;
                }[];
                /** @min 0 */
                TotalCount: number;
              };
              postmarkClicksDetails?: string[];
              postmarkOutboundEvents?: {
                Type: "Delivered" | "Opened" | "Bounced" | "Failed" | "SubscriptionChanged";
                Details?: {
                  DestinationIP?: string;
                  DeliveryMessage?: string;
                  DestinationServer?: string;
                  Summary?: string;
                  BounceID?: string;
                };
                Recipient: string;
                /** @format date-time */
                ReceivedAt: Date;
              }[];
              tags: string[];
              /** @format date */
              messageDate: Date;
              /** @format date */
              createdAt?: Date;
              messageType: "RECEIVED" | "SENT";
              claimId?: string;
              automatedWorkflowId?: string;
            }[];
          };
          expensesSequence: {
            id: string;
            /** @example "family-claim-acquisition-confirmation" */
            workflowTypeKey: string;
            claimId: string;
            thirdRunId?: string;
            /** @min 0 */
            currentStepNumber: number;
            /** @format date-time */
            triggeredAt?: Date;
            /** @format date-time */
            completedAt?: Date;
            /** @format date-time */
            lastRun?: Date;
            /** @format date-time */
            cancelledAt?: Date;
            /** @format date-time */
            expirationDate?: Date;
            emails: {
              id: string;
              inboxId: string;
              emlFileId?: string;
              pdfFileId?: string;
              to: string[];
              fromEmail: string;
              fromName?: string;
              cc?: string[];
              bcc?: string[];
              subject: string;
              textBody: string;
              htmlBody: string;
              headers?: string[];
              messageId: string;
              replyTo?: string;
              inReplyTo?: string;
              references: string[];
              blockedReason?: string;
              status: string;
              postmarkOpensDetails?: {
                Opens?: {
                  OS?: {
                    Name?: string;
                    Family?: string;
                    Company?: string;
                  };
                  Geo?: {
                    IP?: string;
                    Zip?: string;
                    City?: string;
                    Coords?: string;
                    Region?: string;
                    Country?: string;
                    RegionISOCode?: string;
                    CountryISOCode?: string;
                  };
                  Tag?: string;
                  Client?: {
                    Name?: string;
                    Family?: string;
                    Company?: string;
                  };
                  Platform?: string;
                  MessageID: string;
                  Recipient: string;
                  UserAgent?: string;
                  /** @format date-time */
                  ReceivedAt: Date;
                  RecordType: "Open" | "Click" | "Bounce" | "Spam";
                  /** @min 0 */
                  ReadSeconds?: number;
                  MessageStream?: string;
                }[];
                /** @min 0 */
                TotalCount: number;
              };
              postmarkClicksDetails?: string[];
              postmarkOutboundEvents?: {
                Type: "Delivered" | "Opened" | "Bounced" | "Failed" | "SubscriptionChanged";
                Details?: {
                  DestinationIP?: string;
                  DeliveryMessage?: string;
                  DestinationServer?: string;
                  Summary?: string;
                  BounceID?: string;
                };
                Recipient: string;
                /** @format date-time */
                ReceivedAt: Date;
              }[];
              tags: string[];
              /** @format date */
              messageDate: Date;
              /** @format date */
              createdAt?: Date;
              messageType: "RECEIVED" | "SENT";
              claimId?: string;
              automatedWorkflowId?: string;
            }[];
          };
          additionalDocsSequence: {
            id: string;
            /** @example "family-claim-acquisition-confirmation" */
            workflowTypeKey: string;
            claimId: string;
            thirdRunId?: string;
            /** @min 0 */
            currentStepNumber: number;
            /** @format date-time */
            triggeredAt?: Date;
            /** @format date-time */
            completedAt?: Date;
            /** @format date-time */
            lastRun?: Date;
            /** @format date-time */
            cancelledAt?: Date;
            /** @format date-time */
            expirationDate?: Date;
            emails: {
              id: string;
              inboxId: string;
              emlFileId?: string;
              pdfFileId?: string;
              to: string[];
              fromEmail: string;
              fromName?: string;
              cc?: string[];
              bcc?: string[];
              subject: string;
              textBody: string;
              htmlBody: string;
              headers?: string[];
              messageId: string;
              replyTo?: string;
              inReplyTo?: string;
              references: string[];
              blockedReason?: string;
              status: string;
              postmarkOpensDetails?: {
                Opens?: {
                  OS?: {
                    Name?: string;
                    Family?: string;
                    Company?: string;
                  };
                  Geo?: {
                    IP?: string;
                    Zip?: string;
                    City?: string;
                    Coords?: string;
                    Region?: string;
                    Country?: string;
                    RegionISOCode?: string;
                    CountryISOCode?: string;
                  };
                  Tag?: string;
                  Client?: {
                    Name?: string;
                    Family?: string;
                    Company?: string;
                  };
                  Platform?: string;
                  MessageID: string;
                  Recipient: string;
                  UserAgent?: string;
                  /** @format date-time */
                  ReceivedAt: Date;
                  RecordType: "Open" | "Click" | "Bounce" | "Spam";
                  /** @min 0 */
                  ReadSeconds?: number;
                  MessageStream?: string;
                }[];
                /** @min 0 */
                TotalCount: number;
              };
              postmarkClicksDetails?: string[];
              postmarkOutboundEvents?: {
                Type: "Delivered" | "Opened" | "Bounced" | "Failed" | "SubscriptionChanged";
                Details?: {
                  DestinationIP?: string;
                  DeliveryMessage?: string;
                  DestinationServer?: string;
                  Summary?: string;
                  BounceID?: string;
                };
                Recipient: string;
                /** @format date-time */
                ReceivedAt: Date;
              }[];
              tags: string[];
              /** @format date */
              messageDate: Date;
              /** @format date */
              createdAt?: Date;
              messageType: "RECEIVED" | "SENT";
              claimId?: string;
              automatedWorkflowId?: string;
            }[];
          };
          enterprise: {
            id: string;
            travelAgencyId: string;
            companyId: string;
            /** @example "radiofrance.fr" */
            domain: string;
            /** @example "Radio France" */
            displayName: string;
            /** @example "RADIO FRANCE" */
            rawGdsName: string;
            iconUrl: string;
            mainContactEmail: string;
            defaultTravelAgentAdminId: string;
            accountManagerId: string;
            bluebizIdentifier?: string;
            isDirectPassengerContactAllowed: boolean;
            passengersSignaturesForwardEmail: string;
            /** @format date-time */
            createdAt: Date;
            /** @format date-time */
            lastModified: Date;
          };
          family: {
            id: string;
            claimId: string;
            familyName: string;
            signerFullname?: string;
            /** For communicating with the family (signature request, events, etc) */
            email: string;
            usersClaims: {
              id: string;
              userId: string;
              userFlightId?: string;
              claimId: string;
              familyId: string;
              /** @min 1 */
              abortionId: number;
              /** @min 1 */
              legalDocumentsId: number;
              /** If White Label is set, we do not exist for the passengers:      No direct email, SMS or even Dashboard access for them */
              isWhiteLabel: boolean;
              /** Soft delete (Because of declined signature, etc */
              isRemoved: boolean;
              /**
               * Flight compensation amount as per Montreal Convention
               * @example 1250.89
               */
              montrealConventionCompensationAmount?: string;
              /** To prevent side-effects when creating manual claims */
              email: string;
              /** @format date-time */
              createdAt: Date;
              /** @format date-time */
              lastModified: Date;
              user: {
                id: string;
                /** @example "Eric" */
                firstName: string;
                /** @example "Dupont" */
                lastName: string;
                /** @example "DUPONT/ERIC" */
                rawGdsName?: string;
                /** @example "eric.dupont@gmail.com" */
                email: string;
                /** @example "+33642424242" */
                phone: string;
                /**
                 * 2 letters ISO country code
                 * @minLength 2
                 * @maxLength 2
                 * @example "FR"
                 */
                nationalityCountryCode: string;
                /** @format date */
                birthdate: Date;
                /**
                 * ISO/IEC 5218: 1 for male, 2 for female
                 * @min 0
                 * @max 9
                 */
                civility: number;
                /** @min 1 */
                postalAddressId?: number;
                /** @format date-time */
                createdAt: Date;
                /** @format date-time */
                lastModified: Date;
              };
              expenses: {
                id: number;
                userClaimId: string;
                expenseId: number;
                expense: {
                  id: number;
                  expenseTypeId: number;
                  /** DecimalJS */
                  price: string;
                  /**
                   * @minLength 3
                   * @maxLength 3
                   * @example "EUR"
                   */
                  currencyCode: string;
                  isLostPrestation: boolean;
                  expenseName?: string;
                  claimDocumentId?: string;
                  createdBy?: string;
                  /** @format date-time */
                  createdAt: Date;
                  /** @format date-time */
                  lastModified: Date;
                  expenseType: {
                    id: number;
                    type:
                      | "TRAIN"
                      | "HOTEL"
                      | "TAXI"
                      | "OUTBOUND_FLIGHT"
                      | "RETURN_FLIGHT"
                      | "FOOD"
                      | "PHONE_PLAN"
                      | "TRAVEL_PACKAGE_SERVICE"
                      | "OTHER"
                      | "SALARY_COMPENSATION";
                  };
                  claimDocument?: {
                    id: string;
                    claimId: string;
                    adminId: string;
                    /** @min 0 */
                    documentTypeId: number;
                    fileId: string;
                    description: string;
                    /** @format date-time */
                    createdAt: Date;
                    /** @format date-time */
                    lastModified: Date;
                    documentType: {
                      /** @min 0 */
                      id: number;
                      type:
                        | "KBIS_UPCLAIM"
                        | "INVOICES_MERGED"
                        | "CLAIM_NOTIFICATION"
                        | "ELIGIBILITY_PROOF"
                        | "RIB_UPCLAIM"
                        | "FIRST_CONCILIATION_ATTEMPT"
                        | "MED"
                        | "MED_RECEIPT"
                        | "ESCP_A"
                        | "ESCP_B"
                        | "ESCP_C"
                        | "ESCP_D"
                        | "COURT_DECISION"
                        | "PLEADING_FILE"
                        | "OTHER"
                        | "LEGAL_SUBPOENA_SERVED"
                        | "DEBT_CONTRACT"
                        | "LEGAL_SUBPOENA_TO_REVIEW"
                        | "KBIS_OPPONENT"
                        | "ID_PROOF"
                        | "ETICKET"
                        | "DEBT_CONTRACT_ENTERPRISE"
                        | "DEBT_CONTRACT_TRAVEL_AGENCY_TO_UPCLAIM"
                        | "PROOF_OF_EXPENSE"
                        | "RECEIVABLE_TRAIL";
                    };
                    file: {
                      id: string;
                      name: string;
                      size: number;
                      /** @example "application/pdf" */
                      mimeType: string;
                      path: string;
                      fileId: string;
                      /** @example "1274366276920" */
                      boxFileId: string;
                      /** @example "1274366276920" */
                      sha512: string;
                      /** @format date-time */
                      createdAt: Date;
                      /** @format date-time */
                      lastModified: Date;
                    };
                    admin?: {
                      id: string;
                      tenantId: string;
                      auth0Id: string;
                      boxUserId: string;
                      slackUserId: string;
                      fullName: string;
                      email: string;
                      phone: string;
                      isActive: boolean;
                      invited: boolean;
                      lawFirmId: string;
                      legalContactPhone?: string;
                      frontUserId?: string;
                      /** @example "https://ucarecdn.com/d8702beb-c658-4751-aabf-768c42e6d36a/-/preview/400x400/" */
                      profilePictureUrl: string;
                      /** @format date-time */
                      createdAt: Date;
                      /** @format date-time */
                      lastModified: Date;
                      roleId: number;
                    };
                  };
                };
              }[];
            }[];
          };
        }[];
        enterprise: {
          id: string;
          claimId: string;
          enterpriseId?: string;
          enterpriseReferentEmail?: string;
          toEmail: string;
          fromEmail: string;
          signatureRequestId: string;
          /** @default "EXPENSES" */
          step: "CONFIRM" | "EXPENSES" | "SIGNATURE" | "COMPLETE" | "DECLINED" | "EXPIRED";
          /** @default "EXPENSES,SIGNATURE,COMPLETE" */
          stepsSequence: string;
          expensesSequenceId: string;
          additionalDocsSequenceId: string;
          accountManagerEmail: string;
          accountManagerFeedbackSequenceId: string;
          /** @format date-time */
          accountManagerFeedbackCompletedAt: Date;
          /** @format date-time */
          expirationDate: Date;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          linkClickedAt: Date;
          accountManagerNote: string;
          enterpriseReferentNote: string;
          /** @format date-time */
          stepUpdatedAt: Date;
        };
      },
      any
    >({
      path: `/admin/claims/${id}/acquisitions`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Will add User in every impacted reservation's segments
   *
   * @tags Admin
   * @name AddPassengers
   * @summary Add one or many passenger(s) into specified claim
   * @request POST:/admin/claims/{id}/passengers
   * @secure
   */
  addPassengers = (
    id: string,
    body: {
      /** @minItems 1 */
      users: {
        firstName: string;
        lastName: string;
        /** @example "romain@upclaim.eu" */
        email?: string;
        phone?: string;
        /** @format date */
        birthDate?: Date;
        /**
         * ISO/IEC 5218: 1 for male, 2 for female
         * @min 0
         * @max 9
         */
        civility?: number;
        /**
         * 2 letters ISO country code
         * @minLength 2
         * @maxLength 2
         * @example "FR"
         */
        nationalityCountryCode?: string;
        reservationId?: string;
        ticketNumber?: string;
      }[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/passengers`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description This will **definitively** close all specified user's claim
   *
   * @tags Admin
   * @name RemovePassengers
   * @summary Extract one or many passenger(s) from a claim
   * @request DELETE:/admin/claims/{id}/passengers
   * @secure
   */
  removePassengers = (
    id: string,
    body: {
      /** @minItems 1 */
      usersIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/passengers`,
      method: "DELETE",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Will store the file and Uploadcare and save the link
   *
   * @tags Admin
   * @name AddClaimDocument
   * @summary Add a document to a claim
   * @request POST:/admin/claims/{id}/documents
   * @secure
   */
  addClaimDocument = (
    id: string,
    body: {
      name: string;
      description?: string;
      boxFileId?: string;
      /** Document as DataURL (based64 encoded) */
      document?: string;
      /** @example "application/pdf" */
      mimeType?: string;
      claimDocumentType: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/documents`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name InitClaim
   * @summary Init claim, after all contracts have been signed
   * @request POST:/admin/claims/{id}/init
   * @secure
   */
  initClaim = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/init`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name AddClaimExpense
   * @summary Add a claim expense (Travel agency's loss, or paid by employee's company)
   * @request POST:/admin/claims/{id}/expense
   * @secure
   */
  addClaimExpense = (
    id: string,
    body: {
      paidBy: string;
      expense: {
        expenseType:
          | "TRAIN"
          | "HOTEL"
          | "TAXI"
          | "OUTBOUND_FLIGHT"
          | "RETURN_FLIGHT"
          | "FOOD"
          | "PHONE_PLAN"
          | "TRAVEL_PACKAGE_SERVICE"
          | "OTHER"
          | "SALARY_COMPENSATION";
        price: {
          currency: string;
          precision: 2;
          /** @min 10 */
          amount?: number;
        };
        isLostPrestation: boolean;
        expenseName: string;
        file?: {
          name: string;
          description?: string;
          /** Document as DataURL (based64 encoded) */
          document: string;
          /** @example "application/pdf" */
          mimeType?: string;
        };
      };
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/expense`,
      method: "POST",
      body: body,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SyncCompanyPappersData
   * @summary Sync a company Pappers data
   * @request POST:/admin/companies/{id}/sync-pappers
   * @secure
   */
  syncCompanyPappersData = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        id: string;
        /** @example "Upclaim" */
        name: string;
        /**
         * @pattern ^[0-9]{9}$
         * @example "890120587"
         */
        siren: string;
        /**
         * @pattern ^[0-9]{14}$
         * @example "89012058700021"
         */
        siret: string;
        /**
         * @pattern ^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$
         * @example "ATU72316013"
         */
        euVAT: string;
        /** @example "upclaim.eu" */
        domain?: string;
        logoUrl?: string;
        pappersData?: string;
        boxFolderId?: string;
        kbisBoxFileId?: string;
        /** @format date-time */
        pappersDataSyncedAt: Date;
        postalAddressId?: number;
        /** Tribunal de commerce en fonction du siège de la société */
        competentCourtId?: number;
        /**
         * Pour override celles générées à partir des Pappers data
         * @example "UPCLAIM, société par actions simplifiée au capital social de 1500 €, dont le siège social est situé au 88 BD VOLTAIRE 75011 PARIS 11, immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 890 120 587, représentée par M. Victor Boinet agissant et ayant les pouvoirs nécessaires en tant que président."
         */
        legalNotices?: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        lastModified: Date;
        postalAddress?: {
          /** @min 1 */
          id: number;
          /** Address label description */
          label?: string;
          nameLine?: string;
          /** @example "34 rue de l'Echiquier" */
          streetAddress: string;
          streetAddressComplement?: string;
          /** @example "Paris" */
          city: string;
          /** @example "75010" */
          zipCode: string;
          /** @example "Île-de-France" */
          region: string;
          /**
           * @minLength 2
           * @maxLength 2
           * @example "FR"
           */
          countryCode: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          updatedAt?: Date;
        };
        juridiction?: {
          /** @min 1 */
          id: number;
          /** @example "Tribunal judiciaire Paris" */
          name: string;
          /** @min 1 */
          postalAddressId: number;
          /** @example 6401 */
          code: number;
          /** @example "www.greffe-tc-dax.fr" */
          website: string;
          /** @example "09h-12h/14h-17h" */
          schedule: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
      },
      any
    >({
      path: `/admin/companies/${id}/sync-pappers`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name UploadCompanyKbis
   * @summary Retrieve a company detail
   * @request POST:/admin/companies/{id}/kbis
   * @secure
   */
  uploadCompanyKbis = (
    id: string,
    body: {
      name: string;
      description?: string;
      /** Document as DataURL (based64 encoded) */
      document: string;
      /** @default "application/pdf" */
      mimeType?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        id: string;
        /** @example "Upclaim" */
        name: string;
        /**
         * @pattern ^[0-9]{9}$
         * @example "890120587"
         */
        siren: string;
        /**
         * @pattern ^[0-9]{14}$
         * @example "89012058700021"
         */
        siret: string;
        /**
         * @pattern ^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$
         * @example "ATU72316013"
         */
        euVAT: string;
        /** @example "upclaim.eu" */
        domain?: string;
        logoUrl?: string;
        pappersData?: string;
        boxFolderId?: string;
        kbisBoxFileId?: string;
        /** @format date-time */
        pappersDataSyncedAt: Date;
        postalAddressId?: number;
        /** Tribunal de commerce en fonction du siège de la société */
        competentCourtId?: number;
        /**
         * Pour override celles générées à partir des Pappers data
         * @example "UPCLAIM, société par actions simplifiée au capital social de 1500 €, dont le siège social est situé au 88 BD VOLTAIRE 75011 PARIS 11, immatriculée au Registre du Commerce et des Sociétés de Paris sous le numéro 890 120 587, représentée par M. Victor Boinet agissant et ayant les pouvoirs nécessaires en tant que président."
         */
        legalNotices?: string;
        /** @format date-time */
        createdAt: Date;
        /** @format date-time */
        lastModified: Date;
        postalAddress?: {
          /** @min 1 */
          id: number;
          /** Address label description */
          label?: string;
          nameLine?: string;
          /** @example "34 rue de l'Echiquier" */
          streetAddress: string;
          streetAddressComplement?: string;
          /** @example "Paris" */
          city: string;
          /** @example "75010" */
          zipCode: string;
          /** @example "Île-de-France" */
          region: string;
          /**
           * @minLength 2
           * @maxLength 2
           * @example "FR"
           */
          countryCode: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          updatedAt?: Date;
        };
        juridiction?: {
          /** @min 1 */
          id: number;
          /** @example "Tribunal judiciaire Paris" */
          name: string;
          /** @min 1 */
          postalAddressId: number;
          /** @example 6401 */
          code: number;
          /** @example "www.greffe-tc-dax.fr" */
          website: string;
          /** @example "09h-12h/14h-17h" */
          schedule: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
      },
      any
    >({
      path: `/admin/companies/${id}/kbis`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Specified Box File should have `usersClaimsIds` metadata set
   *
   * @tags Admin
   * @name SendSignatureRequest
   * @summary Send a Box signature request
   * @request POST:/admin/files/{boxFileId}/signature-request
   * @secure
   */
  sendSignatureRequest = (
    boxFileId: string,
    body: {
      claimId: string;
      signerEmail: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<string, any>({
      path: `/admin/files/${boxFileId}/signature-request`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name MonitorFlight
   * @summary Monitor specified flight (refresh tracking data if already present)
   * @request POST:/admin/flights/{id}/monitor
   * @secure
   */
  monitorFlight = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/flights/${id}/monitor`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SendDomainConfigurationEmail
   * @summary Send domain configuration instruction email
   * @request POST:/admin/tenants/current/send-domain-instruction-email
   * @secure
   */
  sendDomainConfigurationEmail = (
    body: {
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/tenants/current/send-domain-instruction-email`,
      method: "POST",
      body: body,
      secure: true,
      ...params,
    });
  /**
   * @description Will return generate the PDFs file and upload them in Box
   *
   * @tags Admin
   * @name GenerateTravelAgencyToUpclaimReceivable
   * @summary Generate travel agency to Upclaim receivable contract(s) for specified claim
   * @request POST:/admin/claims/{id}/documents/generate-travel-agency-to-upclaim-receivable
   * @secure
   */
  generateTravelAgencyToUpclaimReceivable = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/claims/${id}/documents/generate-travel-agency-to-upclaim-receivable`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin, validation
   * @name SaveAgentFeedbackAdditionalLoss
   * @summary Save form additional loss
   * @request POST:/admin/claims/{id}/agent-feedback/additional-loss
   * @secure
   */
  saveAgentFeedbackAdditionalLoss = (id: string, body: object, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/agent-feedback/additional-loss`,
      method: "POST",
      body: body,
      secure: true,
      ...params,
    });
  /**
   * @description They will fill the `additional loss` form
   *
   * @tags Admin, validation
   * @name ValidationAskForAccountManagerFeedback
   * @summary Send Email to the account manager, when a confirmed claim concern their company
   * @request POST:/admin/claims/{id}/notify/ask-for-account-manager-feedback
   * @secure
   */
  validation_askForAccountManagerFeedback = (
    id: string,
    body: {
      accountManagerEmail: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/notify/ask-for-account-manager-feedback`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Will affect passengers signatures
   *
   * @tags Admin
   * @name InitPassengers
   * @summary Init families (by familly names)
   * @request POST:/admin/claims/{id}/passengers/init-families
   * @secure
   */
  initPassengers = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/passengers/init-families`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin, validation
   * @name SaveAgentFeedbackClaimValidation
   * @summary Save Agent feedback - Claim confirmation
   * @request POST:/admin/claims/{id}/agent-feedback/validation
   * @secure
   */
  saveAgentFeedbackClaimValidation = (
    id: string,
    body: {
      optionId: number;
      /** Was travel B2C or B2B? */
      b2c: boolean;
      note?: string;
      receivableContract?: string;
      additionalFiles?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/agent-feedback/validation`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Will return generate the PDFs file and upload them in Box
   *
   * @tags Admin
   * @name GenerateReceivableContract
   * @summary Generate receivable contract(s) for specified claim
   * @request POST:/admin/claims/{id}/documents/receivable-contract
   * @secure
   */
  generateReceivableContract = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/claims/${id}/documents/receivable-contract`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Will return generate the PDFs file and upload them in Box
   *
   * @tags Admin
   * @name GenerateNotificationDocument
   * @summary Generate claim notification document
   * @request POST:/admin/claims/{id}/documents/generate-notification-document
   * @secure
   */
  generateNotificationDocument = (id: string, params: RequestParams = {}) =>
    this.request<string, any>({
      path: `/admin/claims/${id}/documents/generate-notification-document`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Will return generate the PDFs file and upload them in Box
   *
   * @tags Admin
   * @name MergeFormalNotice
   * @summary Merge formal notice document
   * @request POST:/admin/claims/{id}/documents/formal-notice/merge
   * @secure
   */
  mergeFormalNotice = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        formalNoticeDocument: {
          id: string;
          claimId: string;
          adminId: string;
          /** @min 0 */
          documentTypeId: number;
          fileId: string;
          description: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
      },
      any
    >({
      path: `/admin/claims/${id}/documents/formal-notice/merge`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name GenerateFormalNoticeProject
   * @summary Generate formal notice project (.docx document)
   * @request POST:/admin/claims/{id}/documents/formal-notice/project
   * @secure
   */
  generateFormalNoticeProject = (
    id: string,
    body: {
      claimDocumentsIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        docxBoxFileId: string;
      },
      any
    >({
      path: `/admin/claims/${id}/documents/formal-notice/project`,
      method: "POST",
      body: body,
      secure: true,
      ...params,
    });
  /**
   * @description Family is upserted using first+last user name
   *
   * @tags Admin
   * @name ExtractInNewFamily
   * @summary Extract specified UserClaim in a new family
   * @request POST:/admin/claims/{id}/passengers/{userClaimId}/families
   * @secure
   */
  extractInNewFamily = (id: string, userClaimId: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/passengers/${userClaimId}/families`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description We still need agent or passenger confirmation before sending any document
   *
   * @tags Admin, validation
   * @name ValidationAskForAgentFeedback
   * @summary Send Email to ask for agent feedback on a new claim
   * @request POST:/admin/claims/{id}/notify/validation/ask-for-agent-feedback
   * @secure
   */
  validation_askForAgentFeedback = (
    id: string,
    body: {
      agentEmail: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/notify/validation/ask-for-agent-feedback`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Called once generated receivables are confirmed
   *
   * @tags Admin, validation
   * @name ValidationNotifyReceivablesContractsReady
   * @summary Send Email to the agent or account manager to alert them documents are ready
   * @request POST:/admin/claims/{id}/notify/validation/receivables-ready
   * @secure
   */
  validation_notifyReceivablesContractsReady = (
    id: string,
    body: {
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/notify/validation/receivables-ready`,
      method: "POST",
      body: body,
      secure: true,
      ...params,
    });
  /**
   * @description This is use by account managers, to keep track of what they already sent, and send follow-up when needed
   *
   * @tags Admin, validation
   * @name SetAdditionalLossRequestDate
   * @summary Set the date where additional loss request was sent to the company
   * @request POST:/admin/claims/{id}/agent-feedback/additional-loss/date
   * @secure
   */
  setAdditionalLossRequestDate = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/agent-feedback/additional-loss/date`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name GenerateLegalSubpoenaProject
   * @summary Generate legal subpoena project (.docx document)
   * @request POST:/admin/claims/{id}/documents/legal-subpoena/project
   * @secure
   */
  generateLegalSubpoenaProject = (
    id: string,
    body: {
      claimDocumentsIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        docxBoxFileId: string;
      },
      any
    >({
      path: `/admin/claims/${id}/documents/legal-subpoena/project`,
      method: "POST",
      body: body,
      secure: true,
      ...params,
    });
  /**
   * @description Will return generate the PDFs file and upload them in Box
   *
   * @tags Admin
   * @name MergeLegalSubpoena
   * @summary Merge legal subpoena document
   * @request POST:/admin/claims/{id}/documents/legal-subpoena/merge
   * @secure
   */
  mergeLegalSubpoena = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        legalSubpoenaDocument: {
          id: string;
          claimId: string;
          adminId: string;
          /** @min 0 */
          documentTypeId: number;
          fileId: string;
          description: string;
          /** @format date-time */
          createdAt: Date;
          /** @format date-time */
          lastModified: Date;
        };
      },
      any
    >({
      path: `/admin/claims/${id}/documents/legal-subpoena/merge`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SyncReservation
   * @summary Ask to sync a specific reservation, ahead of the algorithm
   * @request POST:/admin/gds-offices/{officeId}/pnr/{gdsPnrId}/sync
   * @secure
   */
  syncReservation = (officeId: string, gdsPnrId: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
        claimCount: number;
      },
      any
    >({
      path: `/admin/gds-offices/${officeId}/pnr/${gdsPnrId}/sync`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Download an attachment from Front, copy it on S3 an link it to the claim
   *
   * @tags Admin
   * @name AddClaimAttachment
   * @summary Deprecated - Add a front attachment to a claim
   * @request POST:/admin/plugins/front-app/claims/{id}/attachments
   * @secure
   */
  addClaimAttachment = (
    id: string,
    body: {
      frontAttachmentId: string;
      name: string;
      type: string;
      size: number;
      sender: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        id: string;
        name: string;
        size: number;
        type: string;
        sender: string;
        claimId: string;
        frontAttachmentId: string;
        /** @format date-time */
        createdAt: Date;
      },
      any
    >({
      path: `/admin/plugins/front-app/claims/${id}/attachments`,
      method: "POST",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Normally, this is done automatically by the API when a claim is created
   *
   * @tags Admin
   * @name InitFrontConversation
   * @summary Create draft in Front for the first message to send
   * @request POST:/admin/plugins/front-app/claims/{id}/create-draft
   * @secure
   */
  initFrontConversation = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/plugins/front-app/claims/${id}/create-draft`,
      method: "POST",
      secure: true,
      ...params,
    });
  /**
   * @description Will permanently delete specified file
   *
   * @tags Admin
   * @name DeleteClaimDocument
   * @summary Delete a claim's document
   * @request DELETE:/admin/claim-documents/{id}
   * @secure
   */
  deleteClaimDocument = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claim-documents/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name DeleteExpense
   * @summary Delete specified expense along with associated relations
   * @request DELETE:/admin/expenses/{id}
   * @secure
   */
  deleteExpense = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/expenses/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name UnsaveSearch
   * @summary Un-save a search
   * @request DELETE:/admin/search/{id}
   * @secure
   */
  unsaveSearch = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/search/${id}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name ResetClaimTimeline
   * @summary Reset a claim timeline. Can not be used after Validation step.
   * @request DELETE:/admin/claims/{id}/timeline
   * @secure
   */
  resetClaimTimeline = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/timeline`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name DeleteClaimTask
   * @summary Delete specified claim task; Does not mark as completed
   * @request DELETE:/admin/claims/{id}/tasks/{taskId}
   * @secure
   */
  deleteClaimTask = (id: string, taskId: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/tasks/${taskId}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name RemoveLastClaimEvent
   * @summary Remove last claim's event
   * @request DELETE:/admin/claims/{id}/events/last
   * @secure
   */
  removeLastClaimEvent = (id: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/events/last`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * @description 2 example uses cases : After merging a passenger into another claim / After a declined signature
   *
   * @tags Admin
   * @name SoftDeletePassengers
   * @summary Soft delete one or many passenger(s) from specified claim
   * @request DELETE:/admin/claims/{id}/passengers/soft-delete
   * @secure
   */
  softDeletePassengers = (
    id: string,
    body: {
      /** @minItems 1 */
      usersClaimsIds: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/passengers/soft-delete`,
      method: "DELETE",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name DeleteAdditionalRequest
   * @summary Delete additional request from claim
   * @request DELETE:/admin/claims/{id}/additional-request/{requestType}
   * @secure
   */
  deleteAdditionalRequest = (id: string, requestType: string, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/additional-request/${requestType}`,
      method: "DELETE",
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name UpsertClaimGroup
   * @summary Create a claim group
   * @request PUT:/admin/claims/groups
   * @secure
   */
  upsertClaimGroup = (
    body: {
      groupId?: string;
      groupName: string;
      claimsIds?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/groups`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SetPaymentAccountForClaim
   * @summary Attach payment account with specified Claim
   * @request PUT:/admin/claims/{id}/payment-account
   * @secure
   */
  setPaymentAccountForClaim = (
    id: string,
    body: {
      /** @default 1 */
      bankId?: number;
      thirdAccountId?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/payment-account`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Different from adding an expense (MC99 based), see `addClaimExpense`
   *
   * @tags Admin
   * @name UpsertAdditionalRequest
   * @summary Create or update an additional request (Article-700, etc)
   * @request PUT:/admin/claims/{id}/additional-request
   * @secure
   */
  upsertAdditionalRequest = (
    id: string,
    body: {
      reason: string;
      additionalRequestType: "ARTICLE_700" | "PROCEDURE_COSTS" | "ABUSIVE_RESISTANCE" | "LACK_OF_INFORMATION_NOTICE";
      /**
       * In cents, 2 digits precision
       * @min 1
       */
      amountRequested: number;
      /**
       * In cents, 2 digits precision
       * @min 0
       */
      amountReceived?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/additional-request`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name InitTenantSubdomain
   * @summary Init the tenant subdomain (only once)
   * @request PUT:/admin/tenants/current/init
   * @secure
   */
  initTenantSubdomain = (
    body: {
      /** @example "signature.upclaim.eu" */
      subdomain: string;
      /** Whitelabel email used to communicate with passengers on behalf of travel agency */
      email: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        id: string;
        /** @example "Upclaim" */
        name: string;
        tenantType: "TRAVEL_AGENCY" | "ENTERPRISE" | "LAW_FIRM" | "UPCLAIM";
        /** @example "upclaim.eu" */
        domain: string;
        email: string;
        companyId: string;
        brandingId: string;
        /** @format date-time */
        createdAt: Date;
        tenantBranding?: {
          id: string;
          tenantId: string;
          logoUrl: string;
          iconUrl?: string;
          primaryColorHex?: string;
          secondaryColorHex?: string;
          backgroundColorHex?: string;
          twRadiusType?: string;
          signatureBoxUserId: string;
          /** @example "signature.upclaim.eu" */
          subdomainUri: string;
          activeCNAME: boolean;
          emailForPassengerContact?: string;
          whitelabelInboxId?: string;
          yousignWorkspaceId?: string;
          yousignExperienceId?: string;
          senderName?: string;
          replyTo?: string;
          postmarkappDomainId?: string;
          postmarkServerId?: string;
          additionalLogos: string[];
          postmarkappDomain?: {
            ID: string;
            Name: string;
            WeakDKIM: boolean;
            SPFVerified: boolean;
            DKIMVerified: boolean;
            ReturnPathDomainVerified: boolean;
            SPFHost?: string;
            SPFTextValue?: string;
            DKIMHost?: string;
            DKIMTextValue?: string;
            DKIMPendingHost?: string;
            DKIMPendingTextValue?: string;
            DKIMRevokedHost?: string;
            DKIMRevokedTextValue?: string;
            SafeToRemoveRevokedKeyFromDNS?: boolean;
            DKIMUpdateStatus?: "Pending" | "Verified" | "Failed";
            ReturnPathDomain?: string;
            ReturnPathDomainCNAMEValue?: string;
          };
          /** @format date-time */
          lastModified?: Date;
        };
        tenantOnboarding?: {
          id: string;
          tenantId: string;
          currentStepId: string;
          /** @format date-time */
          completedAt?: Date;
          steps?: {
            id: string;
            tenantOnboardingId: string;
            step?:
              | "LEGAL_ASSETS"
              | "DOMAIN"
              | "SIGNATURE"
              | "CLAIM_VALIDATION"
              | "OPT_ADD_EXPENSE"
              | "OPT_INVITE_ADMIN"
              | "OPT_CREATE_ENTERPRISE"
              | "OPT_CREATE_CLAIM";
            /** @format date-time */
            completedAt?: Date;
            data?: string;
          }[];
          currentStep?: {
            id: string;
            tenantOnboardingId: string;
            step?:
              | "LEGAL_ASSETS"
              | "DOMAIN"
              | "SIGNATURE"
              | "CLAIM_VALIDATION"
              | "OPT_ADD_EXPENSE"
              | "OPT_INVITE_ADMIN"
              | "OPT_CREATE_ENTERPRISE"
              | "OPT_CREATE_CLAIM";
            /** @format date-time */
            completedAt?: Date;
            data?: string;
          };
        };
      },
      any
    >({
      path: `/admin/tenants/current/init`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name VerifySubdomainDns
   * @summary Verify the tenant's subdomain configuration (Email, DNS, etc)
   * @request PUT:/admin/tenants/current/verify
   * @secure
   */
  verifySubdomainDNS = (params: RequestParams = {}) =>
    this.request<
      {
        id: string;
        /** @example "Upclaim" */
        name: string;
        tenantType: "TRAVEL_AGENCY" | "ENTERPRISE" | "LAW_FIRM" | "UPCLAIM";
        /** @example "upclaim.eu" */
        domain: string;
        email: string;
        companyId: string;
        brandingId: string;
        /** @format date-time */
        createdAt: Date;
        tenantBranding?: {
          id: string;
          tenantId: string;
          logoUrl: string;
          iconUrl?: string;
          primaryColorHex?: string;
          secondaryColorHex?: string;
          backgroundColorHex?: string;
          twRadiusType?: string;
          signatureBoxUserId: string;
          /** @example "signature.upclaim.eu" */
          subdomainUri: string;
          activeCNAME: boolean;
          emailForPassengerContact?: string;
          whitelabelInboxId?: string;
          yousignWorkspaceId?: string;
          yousignExperienceId?: string;
          senderName?: string;
          replyTo?: string;
          postmarkappDomainId?: string;
          postmarkServerId?: string;
          additionalLogos: string[];
          postmarkappDomain?: {
            ID: string;
            Name: string;
            WeakDKIM: boolean;
            SPFVerified: boolean;
            DKIMVerified: boolean;
            ReturnPathDomainVerified: boolean;
            SPFHost?: string;
            SPFTextValue?: string;
            DKIMHost?: string;
            DKIMTextValue?: string;
            DKIMPendingHost?: string;
            DKIMPendingTextValue?: string;
            DKIMRevokedHost?: string;
            DKIMRevokedTextValue?: string;
            SafeToRemoveRevokedKeyFromDNS?: boolean;
            DKIMUpdateStatus?: "Pending" | "Verified" | "Failed";
            ReturnPathDomain?: string;
            ReturnPathDomainCNAMEValue?: string;
          };
          /** @format date-time */
          lastModified?: Date;
        };
        tenantOnboarding?: {
          id: string;
          tenantId: string;
          currentStepId: string;
          /** @format date-time */
          completedAt?: Date;
          steps?: {
            id: string;
            tenantOnboardingId: string;
            step?:
              | "LEGAL_ASSETS"
              | "DOMAIN"
              | "SIGNATURE"
              | "CLAIM_VALIDATION"
              | "OPT_ADD_EXPENSE"
              | "OPT_INVITE_ADMIN"
              | "OPT_CREATE_ENTERPRISE"
              | "OPT_CREATE_CLAIM";
            /** @format date-time */
            completedAt?: Date;
            data?: string;
          }[];
          currentStep?: {
            id: string;
            tenantOnboardingId: string;
            step?:
              | "LEGAL_ASSETS"
              | "DOMAIN"
              | "SIGNATURE"
              | "CLAIM_VALIDATION"
              | "OPT_ADD_EXPENSE"
              | "OPT_INVITE_ADMIN"
              | "OPT_CREATE_ENTERPRISE"
              | "OPT_CREATE_CLAIM";
            /** @format date-time */
            completedAt?: Date;
            data?: string;
          };
        };
      },
      any
    >({
      path: `/admin/tenants/current/verify`,
      method: "PUT",
      secure: true,
      ...params,
    });
  /**
   * @description This create the link with the Tribunal Digital
   *
   * @tags Admin
   * @name SetProcedureIdentifier
   * @summary Set the `numéro RG` for specified claim
   * @request PUT:/admin/claims/{id}/procedure/identifier
   * @secure
   */
  setProcedureIdentifier = (
    id: string,
    body: {
      numeroRG: string;
      juridictionId?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/procedure/identifier`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Will affect passengers signatures
   *
   * @tags Admin
   * @name UpdateClaimFamilies
   * @summary Replace current claim families with incoming payload
   * @request PUT:/admin/claims/{id}/passengers/families
   * @secure
   */
  updateClaimFamilies = (
    id: string,
    body: {
      families?: {
        familyId: string;
        /** User Claim IDs */
        usersClaimsIds: string[];
      }[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/passengers/families`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * @description Specified claim should be a grouped claim (`isWholeFlightEligible: true`)
   *
   * @tags Admin
   * @name ExtractPassengers
   * @summary Extract one or many passenger(s) into a new claim
   * @request PUT:/admin/claims/{id}/passengers/extract
   * @secure
   */
  extractPassengers = (
    id: string,
    body: {
      /** @minItems 1 */
      usersIds: string[];
      claimTypeName:
        | "FLIGHT_DELAY"
        | "FLIGHT_CANCELLATION"
        | "WRONG_ARRIVAL_AIRPORT"
        | "MISSED_CONNECTION_DUE_TO_DELAY"
        | "OVERBOOKING"
        | "COVID_ORDINANCE_2020"
        | "PNR_SEGMENT_CANCELLATION"
        | "DELAY_FROM_PNR_SCHEDULE"
        | "CONNECTION_DISRUPTION";
      /** @minLength 5 */
      reason: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/passengers/extract`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name UpsertNextHearing
   * @summary Upsert a claim's next hearing
   * @request PUT:/admin/claims/{id}/procedure/next-hearing
   * @secure
   */
  upsertNextHearing = (
    id: string,
    body: {
      /** @format date */
      hearingDate: Date;
      lawyerId: number;
      procedureType: "PROCEDURE_CLASSIQUE" | "ESCP";
      hearingTypeId: number;
      juridictionId: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/procedure/next-hearing`,
      method: "PUT",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name UpdateTravelAgencyCompany
   * @summary Update specified business travel company
   * @request PATCH:/admin/business-travel-companies/{id}
   * @secure
   */
  updateTravelAgencyCompany = (
    id: string,
    body: {
      mainContactEmail?: string;
      defaultTravelAgentAdminId?: string;
      accountManagerId?: string;
      bluebizIdentifier?: string;
      isDirectPassengerContactAllowed?: boolean;
      passengersSignaturesForwardEmail?: string;
      siren?: string;
      domain?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/business-travel-companies/${id}`,
      method: "PATCH",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SaveAdminNote
   * @summary Save EditorJS note
   * @request PATCH:/admin/claims/{id}/note
   * @secure
   */
  saveAdminNote = (id: string, body: object, params: RequestParams = {}) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/note`,
      method: "PATCH",
      body: body,
      secure: true,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name UpdatePassenger
   * @summary Update a passenger
   * @request PATCH:/admin/claims/{id}/passengers/{userSegmentId}
   * @secure
   */
  updatePassenger = (
    id: string,
    userSegmentId: string,
    body: {
      email?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/passengers/${userSegmentId}`,
      method: "PATCH",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags Admin
   * @name SaveCustomerNote
   * @summary Save customer note
   * @request PATCH:/admin/claims/{id}/note/customer
   * @secure
   */
  saveCustomerNote = (
    id: string,
    body: {
      customerNotes?: string;
      passengersQuestion?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      {
        success: boolean;
      },
      any
    >({
      path: `/admin/claims/${id}/note/customer`,
      method: "PATCH",
      body: body,
      secure: true,
      type: ContentType.Json,
      ...params,
    });
}
